import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, inject, Inject, NgModule, LOCALE_ID, signal, ChangeDetectionStrategy, model, computed, TemplateRef, ViewChild, input } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { createCartProductFromProduct } from '@scalefast/core';
import { EMPTY, take as take$1, Subscription, BehaviorSubject, map as map$1, of, asapScheduler, filter } from 'rxjs';
import { take, map, catchError } from 'rxjs/operators';
import { AddToCartComponent, CrossSellProductsComponent as CrossSellProductsComponent$1, ProductAddedToCartComponent as ProductAddedToCartComponent$1, ProductCarouselComponent as ProductCarouselComponent$1, ProductDescriptionTabsComponent, ProductGalleryComponent as ProductGalleryComponent$1, ProductPriceComponent as ProductPriceComponent$1, ProductTitleComponent as ProductTitleComponent$1 } from '@scalefast/components/product';
import * as i1 from '@scalefast/ecommerce-core';
import { SpinnerInterceptor, CategoryPageService, MAINTENANCE_MODE_CONFIG, DATE_NOW_FUNCTION, MaintenanceService, SearchResultsPageService, PrefetchService, SubscribeNewsletterModalService, SubscribeNewsletterService } from '@scalefast/ecommerce-core';
import * as i2 from '@scalefast/config-angular';
import { MaintenanceConfigService, StoreConfigService } from '@scalefast/config-angular';
import { AlertComponent } from '@scalefast/components/alert';
import { NgClass, AsyncPipe, DOCUMENT, NgOptimizedImage, NgTemplateOutlet, NgStyle } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { FormBuilder, FormControl, Validators, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { CustomerInfoFormComponent as CustomerInfoFormComponent$1, ForgotPasswordFormComponent as ForgotPasswordFormComponent$1, LoginButtonComponent as LoginButtonComponent$1, LoginFormComponent as LoginFormComponent$1, RegisterFormComponent as RegisterFormComponent$1, ResetPasswordFormComponent as ResetPasswordFormComponent$1 } from '@scalefast/components/customer';
import { FilterComponent as FilterComponent$1 } from '@scalefast/components/filter';
import { CategoryPageCriteriaFiltersAdapter } from '@scalefast/sam';
import * as i2$1 from '@angular/router';
import { RouterLink, RouterModule, NavigationEnd } from '@angular/router';
import { NgxGlideComponent } from 'ngx-glide';
import { MinicartComponent as MinicartComponent$1, RemoveProductFromCartComponent as RemoveProductFromCartComponent$1 } from '@scalefast/components/minicart';
import { AccordionComponent } from '@scalefast/components/accordion';
import { SearchBarResultsComponent } from '@scalefast/components/search-bar-results';
import { SpinnerComponent as SpinnerComponent$1 } from '@scalefast/components/spinner';
function AlertListComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cm-alert", 0);
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵproperty("message", item_r1.message)("type", item_r1.type);
  }
}
const _c0 = a0 => ({
  "is-invalid": a0
});
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "input", 16);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "input", 16);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "input", 17);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase().toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "input", 18);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_6_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option")(1, "label", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const system_field_option_r4 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", system_field_option_r4.value);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(system_field_option_r4.name);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_6_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, " Option is required. ");
    i0.ɵɵelementEnd();
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "label", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 20)(4, "option", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(6, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_6_For_7_Template, 3, 2, "option", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(8, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_6_Conditional_8_Template, 2, 0, "span", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.description);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", field_r3.raw_title.toLowerCase())("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(field_r3.title_in_portal);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(field_r3.system_field_options);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()]) ? 8 : -1);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "textarea", 24);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "textarea", 24);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_9_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option")(1, "label", 23);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const custom_field_option_r5 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", custom_field_option_r5.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(custom_field_option_r5.name);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_9_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 22);
    i0.ɵɵtext(1, " Option is required. ");
    i0.ɵɵelementEnd();
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "label", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "select", 20)(4, "option", 21);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(6, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_9_For_7_Template, 3, 2, "option", null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵtemplate(8, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_9_Conditional_8_Template, 2, 0, "span", 22);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title_in_portal);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControlName", field_r3.raw_title.toLowerCase())("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", true);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(field_r3.title_in_portal);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(field_r3.custom_field_options);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()]) ? 8 : -1);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "input", 25);
    i0.ɵɵelementStart(2, "label", 11);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const field_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.raw_title.toLowerCase())("placeholder", field_r3.title)("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls[field_r3.raw_title.toLowerCase()])));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(field_r3.title);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4);
    i0.ɵɵtemplate(2, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_2_Template, 4, 10, "div", 9)(3, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_3_Template, 4, 10, "div", 9)(4, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_4_Template, 4, 10, "div", 9)(5, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_5_Template, 4, 10, "div", 9)(6, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_6_Template, 9, 8, "div", 15)(7, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_7_Template, 4, 10, "div", 9)(8, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_8_Template, 4, 10, "div", 9)(9, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_9_Template, 9, 8, "div", 15)(10, ContactFormComponent_Conditional_7_Conditional_9_For_1_Case_10_Template, 4, 10, "div", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_12_0;
    const field_r3 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_12_0 = field_r3.type) === "subject" ? 2 : tmp_12_0 === "text" ? 3 : tmp_12_0 === "decimal" ? 4 : tmp_12_0 === "date" ? 5 : tmp_12_0 === "priority" ? 6 : tmp_12_0 === "description" ? 7 : tmp_12_0 === "textarea" ? 8 : tmp_12_0 === "tagger" ? 9 : tmp_12_0 === "checkbox" ? 10 : -1);
  }
}
function ContactFormComponent_Conditional_7_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, ContactFormComponent_Conditional_7_Conditional_9_For_1_Template, 11, 1, "div", 3, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.zendeskTicketFields);
  }
}
function ContactFormComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 8);
    i0.ɵɵlistener("ngSubmit", function ContactFormComponent_Conditional_7_Template_form_ngSubmit_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submitContactForm());
    });
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelement(2, "input", 10);
    i0.ɵɵelementStart(3, "label", 11);
    i0.ɵɵtext(4, "Name");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 9);
    i0.ɵɵelement(6, "input", 12);
    i0.ɵɵelementStart(7, "label", 11);
    i0.ɵɵtext(8, "Email");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, ContactFormComponent_Conditional_7_Conditional_9_Template, 2, 0);
    i0.ɵɵelementStart(10, "div", 3)(11, "div", 13)(12, "button", 14);
    i0.ɵɵtext(13, "Send");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.zendeskFormGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls["name"])))("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls["name"])));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, ctx_r1.hasRequiredError(ctx_r1.zendeskFormGroup.controls["email"])))("ngClass", i0.ɵɵpureFunction1(12, _c0, ctx_r1.hasValidationError(ctx_r1.zendeskFormGroup.controls["email"])));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.zendeskTicketFields ? 9 : -1);
  }
}
function LanguageSelectorComponent_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const language_r1 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("value", language_r1);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(language_r1);
  }
}
const _forTrack0 = ($index, $item) => $item.id;
const _c1 = () => ({
  product: true
});
function MainCarouselComponent_Conditional_0_Conditional_0_For_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h2", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.title);
  }
}
function MainCarouselComponent_Conditional_0_Conditional_0_For_3_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", item_r1.link);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.btnTitle);
  }
}
function MainCarouselComponent_Conditional_0_Conditional_0_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "img", 3);
    i0.ɵɵelementStart(2, "div", 4)(3, "div", 5);
    i0.ɵɵtemplate(4, MainCarouselComponent_Conditional_0_Conditional_0_For_3_Conditional_4_Template, 2, 1, "h2", 6)(5, MainCarouselComponent_Conditional_0_Conditional_0_For_3_Conditional_5_Template, 2, 2, "a", 7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const $index_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSrc", item_r1.image)("alt", item_r1.title)("height", ctx_r2.imgHeight)("width", ctx_r2.imgWidth)("priority", $index_r2 === 0)("loaderParams", i0.ɵɵpureFunction0(8, _c1));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(item_r1.title ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r1.btnTitle && item_r1.link ? 5 : -1);
  }
}
function MainCarouselComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 0)(1, "ngx-glide", 1);
    i0.ɵɵrepeaterCreate(2, MainCarouselComponent_Conditional_0_Conditional_0_For_3_Template, 6, 9, "div", 2, _forTrack0);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const items_r4 = i0.ɵɵnextContext();
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("showBullets", ctx_r2.bullets)("showArrows", ctx_r2.arrows);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(items_r4);
  }
}
function MainCarouselComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " There is no content for this carousel... ");
  }
}
function MainCarouselComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MainCarouselComponent_Conditional_0_Conditional_0_Template, 4, 2, "section", 0)(1, MainCarouselComponent_Conditional_0_Conditional_1_Template, 1, 0);
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.length > 0 ? 0 : 1);
  }
}
function MainCarouselComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " There is no content for this carousel...\n");
  }
}
function ProductCarouselComponent_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "cm-product-carousel", 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const results_r1 = i0.ɵɵnextContext();
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r1.title)("productList", results_r1.products);
  }
}
function ProductCarouselComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ProductCarouselComponent_Conditional_0_Conditional_0_Template, 2, 2, "div");
  }
  if (rf & 2) {
    i0.ɵɵconditional(ctx.products.length > 0 ? 0 : -1);
  }
}
const _c2 = (a0, a1) => ({
  "btn btn-sm btn-outline-secondary delete-button d-none": a0,
  "btn btn-sm btn-outline-secondary delete-button": a1
});
const _c3 = (a0, a1) => ({
  "search-bar-form-mobile-hide": a0,
  "search-bar-form-mobile d-flex d-block d-sm-none": a1
});
const _c4 = (a0, a1) => ({
  "search-bar__delete-button-hide": a0,
  "search-bar__delete-button": a1
});
function DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Conditional_3_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 7)(1, "a", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const child2_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("routerLink", child2_r1.urlPath);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child2_r1.level3CategoryName);
  }
}
function DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Conditional_3_For_2_Conditional_0_Template, 3, 2, "li", 7);
  }
  if (rf & 2) {
    const child2_r1 = ctx.$implicit;
    i0.ɵɵconditional(child2_r1.visible ? 0 : -1);
  }
}
function DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 6);
    i0.ɵɵrepeaterCreate(1, DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Conditional_3_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(child_r2.level3ChildrenCategs);
  }
}
function DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 5)(1, "a", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Conditional_3_Template, 3, 0, "ul", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("routerLink", child_r2.urlPath);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(child_r2.level2CategoryName);
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r2.level3ChildrenCategs && child_r2.level3ChildrenCategs.length > 0 ? 3 : -1);
  }
}
function DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Conditional_0_Template, 4, 3, "li", 5);
  }
  if (rf & 2) {
    const child_r2 = ctx.$implicit;
    i0.ɵɵconditional(child_r2.visible ? 0 : -1);
  }
}
function DesktopNavComponent_For_3_Conditional_0_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 4);
    i0.ɵɵrepeaterCreate(1, DesktopNavComponent_For_3_Conditional_0_Conditional_4_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(item_r3.level2ChildrenCategs);
  }
}
function DesktopNavComponent_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 2)(1, "a", 3)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, DesktopNavComponent_For_3_Conditional_0_Conditional_4_Template, 3, 0, "ul", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("routerLink", item_r3.urlPath);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", item_r3.level1CategoryName, "");
    i0.ɵɵadvance();
    i0.ɵɵconditional(item_r3.level2ChildrenCategs && item_r3.level2ChildrenCategs.length > 0 ? 4 : -1);
  }
}
function DesktopNavComponent_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, DesktopNavComponent_For_3_Conditional_0_Template, 5, 3, "li", 2);
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    i0.ɵɵconditional(item_r3.visible ? 0 : -1);
  }
}
const _c5 = (a0, a1, a2) => ({
  "col-md-3": a0,
  "col-md-4": a1,
  show: a2
});
const _c6 = a0 => ({
  hide: a0
});
const _c7 = a0 => [a0];
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_For_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 9)(1, "a", 10);
    i0.ɵɵlistener("click", function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_For_4_Conditional_0_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.clickItem());
    });
    i0.ɵɵelement(2, "span", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", item_r5.linkedPage);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", item_r5.title, i0.ɵɵsanitizeHtml);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_For_4_Conditional_0_Template, 3, 2, "li", 9);
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵconditional(!item_r5.hidden ? 0 : -1);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8)(1, "a", 10);
    i0.ɵɵlistener("click", function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_Conditional_5_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.clickItem());
    });
    i0.ɵɵelementStart(2, "span", 12);
    i0.ɵɵi18n(3, 1);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const child_r7 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", child_r7.linkedPage);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const $index_r2 = i0.ɵɵnextContext().$index;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.toggleDropdown($index_r2));
    });
    i0.ɵɵtemplate(1, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "ul", 7);
    i0.ɵɵrepeaterCreate(3, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_For_4_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵtemplate(5, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_Conditional_5_Template, 4, 1, "li", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const child_r7 = ctx_r7.$implicit;
    const $index_r2 = ctx_r7.$index;
    const StoreNavLinkTitle_r9 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", StoreNavLinkTitle_r9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c6, ctx_r2.dropdownOpen() !== $index_r2));
    i0.ɵɵadvance();
    i0.ɵɵrepeater(child_r7.childLinks);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(child_r7.linkedPage ? 5 : -1);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 4);
    i0.ɵɵtemplate(1, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r7 = i0.ɵɵnextContext().$implicit;
    const StoreNavLinkTitle_r9 = i0.ɵɵreference(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c7, child_r7.linkedPage));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", StoreNavLinkTitle_r9);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 13);
  }
  if (rf & 2) {
    const child_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("innerHtml", child_r7.title, i0.ɵɵsanitizeHtml);
  }
}
function EcommerceStoreNavDropdownLinksComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 3);
    i0.ɵɵtemplate(1, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_1_Template, 6, 5)(2, EcommerceStoreNavDropdownLinksComponent_For_2_Conditional_2_Template, 2, 4, "a", 4)(3, EcommerceStoreNavDropdownLinksComponent_For_2_ng_template_3_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r7 = ctx.$implicit;
    const $index_r2 = ctx.$index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(2, _c5, ctx_r2.visibleItems().length >= 4, ctx_r2.visibleItems().length < 4, ctx_r2.dropdownOpen() === $index_r2));
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r7.childLinks ? 1 : 2);
  }
}
const _c8 = a0 => ({
  builder: a0
});
function EcommerceStoreNavDropdownComponent_For_2_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelement(1, "img", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSrc", child_r3.image)("alt", child_r3.title)("loaderParams", i0.ɵɵpureFunction1(3, _c8, !(child_r3 == null ? null : child_r3.skipOptimization)));
  }
}
function EcommerceStoreNavDropdownComponent_For_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 4)(1, "a", 5);
    i0.ɵɵlistener("click", function EcommerceStoreNavDropdownComponent_For_2_Conditional_0_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clickItem());
    });
    i0.ɵɵtemplate(2, EcommerceStoreNavDropdownComponent_For_2_Conditional_0_Conditional_2_Template, 2, 5, "div", 6);
    i0.ɵɵelement(3, "span", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const child_r3 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(3, _c7, child_r3.linkedPage));
    i0.ɵɵadvance();
    i0.ɵɵconditional(child_r3.image && ctx_r1.isVisible ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", child_r3.title, i0.ɵɵsanitizeHtml);
  }
}
function EcommerceStoreNavDropdownComponent_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, EcommerceStoreNavDropdownComponent_For_2_Conditional_0_Template, 4, 5, "li", 4);
  }
  if (rf & 2) {
    const child_r3 = ctx.$implicit;
    i0.ɵɵconditional(!child_r3.hidden ? 0 : -1);
  }
}
function EcommerceStoreNavDropdownComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 9);
    i0.ɵɵlistener("click", function EcommerceStoreNavDropdownComponent_Conditional_4_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clickItem());
    });
    i0.ɵɵi18n(1, 0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c7, ctx_r1.item.linkedPage));
  }
}
const _c9 = (a0, a1, a2, a3, a4, a5, a6) => ({
  "no-image": a0,
  bold: a1,
  italic: a2,
  underline: a3,
  "shape-filled": a4,
  active: a5,
  show: a6
});
const _c10 = a0 => ({
  "btn-underline-hov": a0
});
const _c11 = (a0, a1) => ({
  "background-color": a0,
  color: a1
});
const _c12 = a0 => ({
  show: a0
});
function StoreNavItemComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵlistener("click", function StoreNavItemComponent_Conditional_1_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.clickItem());
    })("mouseenter", function StoreNavItemComponent_Conditional_1_Template_a_mouseenter_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prefetchPage(ctx_r1.item));
    });
    i0.ɵɵelement(1, "span", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(4, _c7, ctx_r1.item.linkedPage))("ngClass", i0.ɵɵpureFunction1(6, _c10, !ctx_r1.shapeColor))("ngStyle", i0.ɵɵpureFunction2(8, _c11, ctx_r1.shapeColor ? ctx_r1.shapeColor : null, ctx_r1.fontColor ? ctx_r1.fontColor : null));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r1.item.title, i0.ɵɵsanitizeHtml);
  }
}
function StoreNavItemComponent_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ecommerce-store-nav-dropdown", 10);
    i0.ɵɵlistener("eventClickItem", function StoreNavItemComponent_Conditional_2_Conditional_6_Template_ecommerce_store_nav_dropdown_eventClickItem_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeDropdown());
    })("clickMenuItem", function StoreNavItemComponent_Conditional_2_Conditional_6_Template_ecommerce_store_nav_dropdown_clickMenuItem_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clickMenuItemHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("item", ctx_r1.item)("isVisible", ctx_r1.isOpen());
  }
}
function StoreNavItemComponent_Conditional_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ecommerce-store-nav-dropdown-links", 10);
    i0.ɵɵlistener("eventClickItem", function StoreNavItemComponent_Conditional_2_Conditional_7_Template_ecommerce_store_nav_dropdown_links_eventClickItem_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.closeDropdown());
    })("clickMenuItem", function StoreNavItemComponent_Conditional_2_Conditional_7_Template_ecommerce_store_nav_dropdown_links_clickMenuItem_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clickMenuItemHandler($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("item", ctx_r1.item)("isVisible", ctx_r1.isOpen());
  }
}
function StoreNavItemComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 4);
    i0.ɵɵlistener("click", function StoreNavItemComponent_Conditional_2_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.toggleDropdown());
    })("mouseenter", function StoreNavItemComponent_Conditional_2_Template_button_mouseenter_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prefetchPage(ctx_r1.item));
    });
    i0.ɵɵelement(2, "span", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5);
    i0.ɵɵlistener("keypress", function StoreNavItemComponent_Conditional_2_Template_div_keypress_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.closeDropdown());
    })("click", function StoreNavItemComponent_Conditional_2_Template_div_click_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.closeDropdown());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 6)(5, "div", 7);
    i0.ɵɵtemplate(6, StoreNavItemComponent_Conditional_2_Conditional_6_Template, 1, 2, "ecommerce-store-nav-dropdown", 8)(7, StoreNavItemComponent_Conditional_2_Conditional_7_Template, 1, 2, "ecommerce-store-nav-dropdown-links", 8);
    i0.ɵɵelementStart(8, "button", 9);
    i0.ɵɵlistener("keypress", function StoreNavItemComponent_Conditional_2_Template_button_keypress_8_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.closeDropdown());
    })("click", function StoreNavItemComponent_Conditional_2_Template_button_click_8_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.closeDropdown());
    });
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c10, !ctx_r1.shapeColor))("id", "dropdown-" + ctx_r1.index)("ngStyle", i0.ɵɵpureFunction2(11, _c11, ctx_r1.shapeColor ? ctx_r1.shapeColor : null, ctx_r1.fontColor ? ctx_r1.fontColor : null));
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHtml", ctx_r1.item.title, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c12, ctx_r1.isOpen()));
    i0.ɵɵadvance();
    i0.ɵɵproperty("id", "megamenu-" + ctx_r1.index)("ngClass", i0.ɵɵpureFunction1(16, _c12, ctx_r1.isOpen()));
    i0.ɵɵattribute("aria-labelledby", "dropdown-" + ctx_r1.index);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r1.linksMenu ? 6 : 7);
  }
}
const _c13 = ["childrenTemplate"];
const _c14 = (a0, a1) => ({
  show: a0,
  sticky: a1
});
function StoreNavComponent_For_9_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 8)(1, "ecommerce-store-nav-item", 9);
    i0.ɵɵtwoWayListener("openedChange", function StoreNavComponent_For_9_Conditional_0_Template_ecommerce_store_nav_item_openedChange_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.opened, $event) || (ctx_r1.opened = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("clickMenuItem", function StoreNavComponent_For_9_Conditional_0_Template_ecommerce_store_nav_item_clickMenuItem_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clickMenuItemHandler($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const item_r4 = ctx_r2.$implicit;
    const $index_r5 = ctx_r2.$index;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("item", item_r4)("index", $index_r5);
    i0.ɵɵtwoWayProperty("opened", ctx_r1.opened);
  }
}
function StoreNavComponent_For_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, StoreNavComponent_For_9_Conditional_0_Template, 2, 3, "li", 8);
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    i0.ɵɵconditional(!item_r4.hidden && item_r4.title ? 0 : -1);
  }
}
const _c15 = () => ["/legals/privacyPolicy"];
const _c16 = (a0, a1) => ({
  "is-invalid": a0,
  "is-valid": a1
});
function SubscribeNewsletterComponent_Conditional_0_Conditional_25_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtext(1, "Thank you for signing up!");
    i0.ɵɵelementEnd();
  }
}
function SubscribeNewsletterComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "h4", 4);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 5);
    i0.ɵɵtext(7, "Lorem ipsum dolor sit amet, vince adipiscing elit, sed do eiusmod tempor incididunt ut labore.");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 3)(9, "form", 6);
    i0.ɵɵlistener("ngSubmit", function SubscribeNewsletterComponent_Conditional_0_Template_form_ngSubmit_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.subscribeNewsletter());
    });
    i0.ɵɵelementStart(10, "div", 7)(11, "div", 8)(12, "input", 9);
    i0.ɵɵlistener("change", function SubscribeNewsletterComponent_Conditional_0_Template_input_change_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPrivacyPolicyCheckChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "label", 10);
    i0.ɵɵtext(14);
    i0.ɵɵelementStart(15, "a", 11);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(17, "div", 8)(18, "input", 12);
    i0.ɵɵlistener("change", function SubscribeNewsletterComponent_Conditional_0_Template_input_change_18_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onPromotionCheckChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "label", 10);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(21, "div", 13)(22, "div", 2)(23, "div", 14);
    i0.ɵɵelement(24, "input", 15);
    i0.ɵɵtemplate(25, SubscribeNewsletterComponent_Conditional_0_Conditional_25_Template, 2, 0, "div", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 17)(27, "button", 18);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd()()()()()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.sectionTitle());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("formGroup", ctx_r1.newsletterForm);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0, ctx_r1.isSubmitted && !ctx_r1.formControls.subscribe_newsletter.enabled))("checked", ctx_r1.isNewsletterChecked);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.checkboxNewsletterText(), " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction0(16, _c15));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.linkText());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", ctx_r1.isPromotionChecked);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.checkboxPromotionText(), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c16, ctx_r1.formControls.email.errors && ctx_r1.formControls.email.value !== "", ctx_r1.isSubmitted && ctx_r1.isNewsletterChecked && !ctx_r1.formControls.email.errors))("placeholder", ctx_r1.emailPlaceholder());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.isSubmitted && ctx_r1.isNewsletterChecked && ctx_r1.subscribedToNewsletter && !ctx_r1.formControls.email.errors ? 25 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", !ctx_r1.isNewsletterChecked || ctx_r1.formControls.email.errors);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.submitLabel(), " ");
  }
}
let ScalefastAddToCartComponent = /*#__PURE__*/(() => {
  class ScalefastAddToCartComponent {
    constructor(addToCartService, destroyRef, storeConfigService) {
      this.addToCartService = addToCartService;
      this.destroyRef = destroyRef;
      this.storeConfigService = storeConfigService;
      this.includeQuantitySelector = false;
      this.loading = false;
      this.productTitle = '';
      this.small = false;
      this.addedToCartEvent = new EventEmitter();
      this.storeConfig = this.storeConfigService.get();
      this.MAX_ITEM_QUANTITY = this.storeConfig.maxItemQuantity;
    }
    ngOnInit() {
      if (this.product?.id) {
        this.addToCartService.getProduct$(this.product.id).pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe(product => {
          if (product) {
            this.cartProduct = createCartProductFromProduct(product);
          }
        });
      }
    }
    ngOnChanges() {
      if (this.product?.id) {
        this.product$ = this.addToCartService.getProduct$(this.product.id).pipe(take(1), takeUntilDestroyed(this.destroyRef)).pipe(map(data => {
          return data;
        }));
      }
    }
    get productDescription() {
      if (!this.product) {
        return '';
      }
      return this.addToCartService.getProductDescription(this.product);
    }
    onResetButton(status) {
      this.loading = this.addToCartService.onResetButton(status);
    }
    onAddToCart(cartProduct) {
      if (this.product) {
        cartProduct.productId = this.product.id;
      }
      this.loading = true;
      // This overide the cartproduct and set the quantity to the correct value, this should not be done by refenrence,
      // instead the subscription should return the correct value
      this.addToCartService.onAddToCart(cartProduct).pipe(catchError(err => {
        console.log(err);
        return EMPTY;
      }), takeUntilDestroyed(this.destroyRef)).subscribe(cartObj => {
        this.loading = false;
        // This should be the correct way to get the quantity, and not cahing the object by reference on the service
        // const currentCartProduct = cartObj.cart.products.find((product) => product.productId === cartProduct.productId);
        if (cartObj.errorCode === 1) {
          this.addedToCartEvent.emit(cartProduct.quantity);
        } else {
          this.addedToCartEvent.emit(cartObj.errorCode);
        }
      });
    }
    static {
      this.ɵfac = function ScalefastAddToCartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ScalefastAddToCartComponent)(i0.ɵɵdirectiveInject(i1.AddToCartService), i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i2.StoreConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ScalefastAddToCartComponent,
        selectors: [["ecommerce-add-to-cart"]],
        inputs: {
          product: "product",
          includeQuantitySelector: "includeQuantitySelector",
          loading: "loading",
          productTitle: "productTitle",
          product$: "product$",
          small: "small"
        },
        outputs: {
          addedToCartEvent: "addedToCartEvent"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 6,
        consts: [[3, "addToCart", "resetAddToCartButton", "cartProduct", "productTitle", "productDescription", "includeQuantitySelector", "loading", "small"]],
        template: function ScalefastAddToCartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cm-add-to-cart", 0);
            i0.ɵɵlistener("addToCart", function ScalefastAddToCartComponent_Template_cm_add_to_cart_addToCart_0_listener($event) {
              return ctx.onAddToCart($event);
            })("resetAddToCartButton", function ScalefastAddToCartComponent_Template_cm_add_to_cart_resetAddToCartButton_0_listener($event) {
              return ctx.onResetButton($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("cartProduct", ctx.cartProduct)("productTitle", ctx.productTitle)("productDescription", ctx.productDescription)("includeQuantitySelector", ctx.includeQuantitySelector)("loading", ctx.loading)("small", ctx.small);
          }
        },
        dependencies: [AddToCartComponent],
        encapsulation: 2
      });
    }
  }
  return ScalefastAddToCartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// FIXME: https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/688
let AlertListComponent = /*#__PURE__*/(() => {
  class AlertListComponent {
    constructor(alertMessageService) {
      this.alertMessageService = alertMessageService;
      this.messages = [];
      this.alertMessageService.getMessage().pipe(takeUntilDestroyed()).subscribe(message => this.messages.push(message));
    }
    static {
      this.ɵfac = function AlertListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AlertListComponent)(i0.ɵɵdirectiveInject(i1.AlertMessageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AlertListComponent,
        selectors: [["ecommerce-alert-list"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [[3, "message", "type"]],
        template: function AlertListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, AlertListComponent_For_1_Template, 1, 2, "cm-alert", 0, i0.ɵɵrepeaterTrackByIdentity);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.messages);
          }
        },
        dependencies: [AlertComponent],
        encapsulation: 2
      });
    }
  }
  return AlertListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// FIXME: https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/688
let ContactFormComponent = /*#__PURE__*/(() => {
  class ContactFormComponent {
    constructor(contactService, alertMessageService, destroyRef, localizationConfigService) {
      this.contactService = contactService;
      this.alertMessageService = alertMessageService;
      this.destroyRef = destroyRef;
      this.localizationConfigService = localizationConfigService;
      this.clearForm = false;
      this.onModalOpen = false;
      this.submitContactFormEvent = new EventEmitter();
      this.formCloseEvent = new EventEmitter();
      this.isFormSended = false;
      this.zendeskTicketFields = [];
      this.localizationConfig = this.localizationConfigService.get();
      this.currentLanguage = this.localizationConfig.currentLang.toLowerCase();
    }
    ngOnChanges(changes) {
      if (changes.onModalOpen && this.onModalOpen) {
        this.getZendeskForm();
      }
      if (changes.zendeskForm && this.zendeskForm) {
        this.zendeskFormGroup = this.buildZendeskForm();
      }
      if (changes.clearForm && this.clearForm && this.zendeskFormGroup) {
        this.resetForm(this.zendeskFormGroup);
      }
    }
    getZendeskForm() {
      this.contactService.getZendeskForm$(this.currentLanguage).pipe(take$1(1), takeUntilDestroyed(this.destroyRef)).subscribe({
        next: zendeskAnswer => {
          // This is the form filtered from the API's answer
          this.zendeskForm = zendeskAnswer.response_data?.ticket_form;
        },
        error: error => {
          this.alertMessageService.sendMessage('It has not been possible to get the contact form', 'danger');
          this.alertMessageService.sendMessage(error.message, 'danger');
          this.formCloseEvent.emit();
        }
      });
    }
    onContactFormSubmit(event) {
      const zendeskSendContactFormParams = {
        lang: this.currentLanguage,
        name: event.name,
        email: event.email,
        subject: event.subject,
        description: event.description,
        ticketFields: this.getZendeskDynamicTicketFields(event)
      };
      this.contactService.sendContactForm$(zendeskSendContactFormParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: zendeskAnswer => {
          if (zendeskAnswer.status === 'OK') {
            this.alertMessageService.sendMessage('The message has been successfully sent. A member of our team will reply as soon as possible', 'success');
            this.formCloseEvent.emit();
            // We need to clear the form here after it has been sended
            this.clearForm = true;
          }
        },
        error: error => {
          this.alertMessageService.sendMessage('It has not been possible to send the contact form', 'danger');
          this.alertMessageService.sendMessage(error.message, 'danger');
          this.formCloseEvent.emit();
        }
      });
    }
    // We're using this method to filter the info that is not mandatory but came in the zendesk request
    getZendeskDynamicTicketFields(ticket_fields) {
      const dynamic_ticket_fields = {};
      for (const [ticket_field_key, ticket_field_value] of Object.entries(ticket_fields)) {
        if (ticket_field_key !== 'name' && ticket_field_key !== 'email' && ticket_field_key !== 'subject' && ticket_field_key !== 'description') {
          dynamic_ticket_fields[ticket_field_key] = ticket_field_value;
        }
      }
      return dynamic_ticket_fields;
    }
    buildZendeskForm() {
      // We need to check if the actual zendesk form is active and visible for the user
      if (!this.zendeskForm || !this.zendeskForm.active || !this.zendeskForm.end_user_visible) {
        return;
      }
      const contactFormGroup = new FormBuilder().group({});
      // These are the fields of the form filtered to get only the active ones
      this.zendeskTicketFields = this.zendeskForm.ticket_fields.filter(ticket_field => ticket_field.active);
      // The name and email fields are not dynamically fetched from Zendesk but are mandatory when submitting the form
      const nameFormControl = new FormControl('', Validators.required);
      contactFormGroup.addControl('name', nameFormControl);
      const emailFormControl = new FormControl('', [Validators.required, Validators.email]);
      contactFormGroup.addControl('email', emailFormControl);
      // Iterate over the zendesk fields, create a form control and add it to the zendesk form group
      this.zendeskTicketFields.forEach(ticket_field => {
        const control = new FormControl('', Validators.required);
        contactFormGroup.addControl(ticket_field.raw_title.toLowerCase(), control);
      });
      return contactFormGroup;
    }
    submitContactForm() {
      this.isFormSended = true;
      if (this.zendeskFormGroup && this.zendeskFormGroup.valid) {
        this.onContactFormSubmit(this.zendeskFormGroup.value);
      }
    }
    hasRequiredError(fieldControl) {
      return this.isFormSended && fieldControl.errors?.['required'];
    }
    hasValidationError(fieldControl) {
      return fieldControl.touched && fieldControl.invalid;
    }
    resetForm(zendeskFormGroup) {
      zendeskFormGroup.reset();
      zendeskFormGroup.markAsPristine();
      Object.keys(zendeskFormGroup.controls).forEach(key => {
        zendeskFormGroup.get(key)?.setErrors(null);
      });
      this.clearForm = false;
    }
    static {
      this.ɵfac = function ContactFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ContactFormComponent)(i0.ɵɵdirectiveInject(i1.ContactService), i0.ɵɵdirectiveInject(i1.AlertMessageService), i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i2.LocalizationConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ContactFormComponent,
        selectors: [["ecommerce-contact-form"]],
        inputs: {
          zendeskForm: "zendeskForm",
          clearForm: "clearForm",
          onModalOpen: "onModalOpen"
        },
        outputs: {
          submitContactFormEvent: "submitContactFormEvent",
          formCloseEvent: "formCloseEvent"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: HTTP_INTERCEPTORS,
          useClass: SpinnerInterceptor,
          multi: true
        }]), i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 8,
        vars: 1,
        consts: () => {
          let i18n_0;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_0 = goog.getMsg(" Submit your order or account inquiry below, our team of experts are on hand to help you as soon as possible. ");
            i18n_0 = MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_0;
          } else {
            i18n_0 = $localize`:@@contact.description: Submit your order or account inquiry below, our team of experts are on hand to help you as soon as possible. `;
          }
          let i18n_1;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_1 = goog.getMsg("All fields are required *");
            i18n_1 = MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_1;
          } else {
            i18n_1 = $localize`:@@contact.required:All fields are required *`;
          }
          return [i18n_0, i18n_1, [1, "container", "contact"], [1, "row"], [1, "col-12"], [1, "contact__description"], [1, "contact__required"], ["novalidate", "", 1, "contact__form", 3, "formGroup"], ["novalidate", "", 1, "contact__form", 3, "ngSubmit", "formGroup"], [1, "input-wrapper", "label-above"], ["type", "text", "id", "00000001", "formControlName", "name", "placeholder", "Name", "required", "", 1, "form-control", 3, "ngClass"], [1, "form-label"], ["type", "email", "id", "00000002", "formControlName", "email", "placeholder", "Email", "required", "", 1, "form-control", 3, "ngClass"], [1, "col-6", "contact__button-wrapper"], ["type", "submit", 1, "btn", "btn-primary"], [1, "text-center"], ["type", "text", "required", "", 1, "form-control", 3, "id", "formControlName", "placeholder", "ngClass"], ["type", "number", "required", "", 1, "form-control", 3, "id", "formControlName", "placeholder", "ngClass"], ["type", "date", "required", "", 1, "form-control", 3, "id", "formControlName", "placeholder", "ngClass"], [1, "mb-2"], [1, "form-select", 3, "formControlName", "ngClass"], ["value", "", 3, "disabled"], [1, "invalid-feedback"], [3, "id"], ["type", "text", "rows", "3", "required", "", 1, "form-control", 3, "id", "formControlName", "placeholder", "ngClass"], ["type", "checkbox", "value", "1", "required", "", 1, "form-control", 3, "id", "formControlName", "placeholder", "ngClass"]];
        },
        template: function ContactFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "div", 4)(3, "p", 5);
            i0.ɵɵi18n(4, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 6);
            i0.ɵɵi18n(6, 1);
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(7, ContactFormComponent_Conditional_7_Template, 14, 14, "form", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(7);
            i0.ɵɵconditional(ctx.zendeskFormGroup ? 7 : -1);
          }
        },
        dependencies: [ReactiveFormsModule, i1$1.ɵNgNoValidate, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i1$1.DefaultValueAccessor, i1$1.NumberValueAccessor, i1$1.CheckboxControlValueAccessor, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.RequiredValidator, i1$1.CheckboxRequiredValidator, i1$1.FormGroupDirective, i1$1.FormControlName, NgClass],
        encapsulation: 2
      });
    }
  }
  return ContactFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CrossSellProductsComponent = /*#__PURE__*/(() => {
  class CrossSellProductsComponent {
    constructor(destroyRef, crossSellProductsService) {
      this.destroyRef = destroyRef;
      this.crossSellProductsService = crossSellProductsService;
      this.addCrossSellProductToCartEventHandler = new EventEmitter();
      this.crossSellProducts = [];
      this.getCrossSellProducts();
    }
    getCrossSellProducts() {
      this.crossSellProductsService.getCrossSellProducts(this.product).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(crossSellProducts => {
        this.crossSellProducts = crossSellProducts;
      });
    }
    addCrossSellProductToCart(crossSellProduct) {
      this.addCrossSellProductToCartEventHandler.emit(crossSellProduct);
      // Refresh the cross sell related products
      this.product = crossSellProduct;
      this.getCrossSellProducts();
    }
    static {
      this.ɵfac = function CrossSellProductsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CrossSellProductsComponent)(i0.ɵɵdirectiveInject(i0.DestroyRef), i0.ɵɵdirectiveInject(i1.CrossSellProductsService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CrossSellProductsComponent,
        selectors: [["ecommerce-cross-sell-products"]],
        inputs: {
          product: "product"
        },
        outputs: {
          addCrossSellProductToCartEventHandler: "addCrossSellProductToCartEventHandler"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "addCrossSellProductToCartEvent", "crossSellProducts"]],
        template: function CrossSellProductsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cm-cross-sell-products", 0);
            i0.ɵɵlistener("addCrossSellProductToCartEvent", function CrossSellProductsComponent_Template_cm_cross_sell_products_addCrossSellProductToCartEvent_0_listener($event) {
              return ctx.addCrossSellProductToCart($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("crossSellProducts", ctx.crossSellProducts);
          }
        },
        dependencies: [CrossSellProductsComponent$1],
        encapsulation: 2
      });
    }
  }
  return CrossSellProductsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CustomerInfoFormComponent = /*#__PURE__*/(() => {
  class CustomerInfoFormComponent {
    constructor(customerService, alertMessageService, legacyConfigService, storeService, destroyRef) {
      this.customerService = customerService;
      this.alertMessageService = alertMessageService;
      this.legacyConfigService = legacyConfigService;
      this.storeService = storeService;
      this.destroyRef = destroyRef;
      this.accountSettingsTitle = 'Account Settings';
      this.firstNameLabel = 'First Name';
      this.firstNamePlaceholder = '';
      this.lastNameLabel = 'Last Name';
      this.lastNamePlaceholder = '';
      this.emailLabel = 'Your email';
      this.emailPlaceholder = '';
      this.dateOfBirthLabel = 'Date of Birth';
      this.dayOfBirthPlaceholder = 'Day';
      this.monthOfBirthPlaceholder = 'Month';
      this.yearOfBirthPlaceholder = 'Year';
      this.countryLabel = 'Country';
      this.countryPlaceholder = 'Select a country';
      this.newsletterText = 'I would like to receive newsletters from Scalefast about news, products and events by email.';
      this.newsletterSecondaryText = '';
      this.promotionsLabel = 'Promotions';
      this.promotionsText = 'I would like to receive special promotions from Scalefast about products and offers by email.';
      this.modifyDetails = 'Modify details';
      this.ChangePassword = 'Change password';
      this.cancelButton = 'Cancel';
      this.customer = {
        type: 'individual',
        email: '',
        firstName: '',
        lastName: '',
        dayOfBirth: 0,
        monthOfBirth: 0,
        yearOfBirth: 0,
        country: '',
        newsletter: false,
        promotions: false
      };
      this.hasNewsletter$ = this.storeService.hasNewsletter$.pipe(map(hasNewsletter => hasNewsletter));
      this.hasPromotions$ = this.legacyConfigService.hasPromotions$.pipe(map(hasPromotions => hasPromotions));
      this.getCustomerSubscription = new Subscription();
      this.updateCustomerSubscription = new Subscription();
      this.hasNewsletterSubscription = new Subscription();
      this.hasPromotionsSubscription = new Subscription();
    }
    ngOnInit() {
      this.hasNewsletterSubscription = this.hasNewsletter$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasNewsletter => this.hasNewsletter = hasNewsletter);
      this.hasPromotionsSubscription = this.hasPromotions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasPromotions => this.hasPromotions = hasPromotions);
      //we need to pass the email to the getCustomer function.
      this.getCustomerSubscription = this.customerService.tryGetCustomer$()?.subscribe({
        next: customer => {
          if (customer) {
            this.customer = customer;
          }
        },
        error: error => {
          this.alertMessageService.sendMessage(error.message, 'danger');
        }
      });
    }
    ngOnDestroy() {
      this.getCustomerSubscription.unsubscribe();
      this.updateCustomerSubscription.unsubscribe();
      this.hasNewsletterSubscription.unsubscribe();
      this.hasPromotionsSubscription.unsubscribe();
    }
    updateCustomer($event) {
      // console.log('angular-core CustomerInfoFormComponent updateCustomer $event', $event);
      !this.hasNewsletter ? delete $event.newsletter : '';
      !this.hasPromotions ? delete $event.promotions : '';
      this.updateCustomerSubscription = this.customerService.updateCustomer$($event).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: data => {
          // FIXME: when API update customer endpoint works, need to update this.customer object and form data from API returned data
          console.log('angular-core CustomerInfoFormComponent updateCustomer data returned from API', data);
        },
        error: error => {
          this.alertMessageService.sendMessage(error.message, 'danger');
        }
      });
    }
    static {
      this.ɵfac = function CustomerInfoFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CustomerInfoFormComponent)(i0.ɵɵdirectiveInject(i1.CustomerService), i0.ɵɵdirectiveInject(i1.AlertMessageService), i0.ɵɵdirectiveInject(i1.LegacyV4ConfigService), i0.ɵɵdirectiveInject(i1.StoreService), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CustomerInfoFormComponent,
        selectors: [["ecommerce-customer-info-form"]],
        inputs: {
          accountSettingsTitle: "accountSettingsTitle",
          firstNameLabel: "firstNameLabel",
          firstNamePlaceholder: "firstNamePlaceholder",
          lastNameLabel: "lastNameLabel",
          lastNamePlaceholder: "lastNamePlaceholder",
          emailLabel: "emailLabel",
          emailPlaceholder: "emailPlaceholder",
          dateOfBirthLabel: "dateOfBirthLabel",
          dayOfBirthPlaceholder: "dayOfBirthPlaceholder",
          monthOfBirthPlaceholder: "monthOfBirthPlaceholder",
          yearOfBirthPlaceholder: "yearOfBirthPlaceholder",
          countryLabel: "countryLabel",
          countryPlaceholder: "countryPlaceholder",
          newsletterText: "newsletterText",
          newsletterSecondaryText: "newsletterSecondaryText",
          promotionsLabel: "promotionsLabel",
          promotionsText: "promotionsText",
          modifyDetails: "modifyDetails",
          ChangePassword: "ChangePassword",
          cancelButton: "cancelButton",
          customer: "customer"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 23,
        consts: [[3, "customerFormEvent", "accountSettingsTitle", "firstNameLabel", "firstNamePlaceholder", "lastNameLabel", "lastNamePlaceholder", "emailLabel", "emailPlaceholder", "dateOfBirthLabel", "dayOfBirthPlaceholder", "monthOfBirthPlaceholder", "yearOfBirthPlaceholder", "countryLabel", "countryPlaceholder", "hasNewsletter", "newsletterText", "newsletterSecondaryText", "hasPromotions", "promotionsText", "customer"]],
        template: function CustomerInfoFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cu-customer-info-form", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵlistener("customerFormEvent", function CustomerInfoFormComponent_Template_cu_customer_info_form_customerFormEvent_0_listener($event) {
              return ctx.updateCustomer($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("accountSettingsTitle", ctx.accountSettingsTitle)("firstNameLabel", ctx.firstNameLabel)("firstNamePlaceholder", ctx.firstNamePlaceholder)("lastNameLabel", ctx.lastNameLabel)("lastNamePlaceholder", ctx.lastNamePlaceholder)("emailLabel", ctx.emailLabel)("emailPlaceholder", ctx.emailPlaceholder)("dateOfBirthLabel", ctx.dateOfBirthLabel)("dayOfBirthPlaceholder", ctx.dayOfBirthPlaceholder)("monthOfBirthPlaceholder", ctx.monthOfBirthPlaceholder)("yearOfBirthPlaceholder", ctx.yearOfBirthPlaceholder)("countryLabel", ctx.countryLabel)("countryPlaceholder", ctx.countryPlaceholder)("hasNewsletter", i0.ɵɵpipeBind1(1, 19, ctx.hasNewsletter$))("newsletterText", ctx.newsletterText)("newsletterSecondaryText", ctx.newsletterSecondaryText)("hasPromotions", i0.ɵɵpipeBind1(2, 21, ctx.hasPromotions$))("promotionsText", ctx.promotionsText)("customer", ctx.customer);
          }
        },
        dependencies: [CustomerInfoFormComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return CustomerInfoFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilterComponent = /*#__PURE__*/(() => {
  class FilterComponent {
    constructor() {
      this.filterService = inject(CategoryPageService);
      this.tagsArray = [];
      this.filtersCriteria = this.filterService.loadFiltersCriteria();
    }
    ngOnInit() {
      this.filtersCriteria = this.filterService.removeExcludedFilters(this.filtersCriteria, this.categoryId);
    }
    filterChange(event) {
      const filters = CategoryPageCriteriaFiltersAdapter.buildPartialFiltersFromMultiSelect(event);
      this.filterService.setFilters(filters);
    }
    removeTagEvent(event) {
      this.filtersCriteria = this.filterService.updateFilterChangedInLoadCriterial(event, this.filtersCriteria);
      const filters = CategoryPageCriteriaFiltersAdapter.buildPartialFiltersFromMultiSelect(event);
      this.filterService.setFilters(filters);
    }
    resetFilters() {
      const emptyFilters = {
        offset: 1,
        pageSize: 12,
        filters: Array(0)
      };
      this.filtersCriteria = this.filterService.resetFilters();
      this.filterService.setFilters(emptyFilters);
      this.filtersCriteria = this.filterService.removeExcludedFilters(this.filtersCriteria, this.categoryId);
    }
    createTagEvent(event) {
      const {
        tagList,
        filter
      } = event;
      this.tagsArray = [JSON.parse(JSON.stringify(this.filterService.createFilterTag(tagList, filter)))];
    }
    static {
      this.ɵfac = function FilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FilterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FilterComponent,
        selectors: [["ecommerce-filter"]],
        inputs: {
          categoryId: "categoryId"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "filterEvent", "removeFilterTagEvent", "createFilterTagEvent", "removeAllTagsEvent", "filters", "tagsArray"]],
        template: function FilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cm-filter", 0);
            i0.ɵɵlistener("filterEvent", function FilterComponent_Template_cm_filter_filterEvent_0_listener($event) {
              return ctx.filterChange($event);
            })("removeFilterTagEvent", function FilterComponent_Template_cm_filter_removeFilterTagEvent_0_listener($event) {
              return ctx.removeTagEvent($event);
            })("createFilterTagEvent", function FilterComponent_Template_cm_filter_createFilterTagEvent_0_listener($event) {
              return ctx.createTagEvent($event);
            })("removeAllTagsEvent", function FilterComponent_Template_cm_filter_removeAllTagsEvent_0_listener() {
              return ctx.resetFilters();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("filters", ctx.filtersCriteria)("tagsArray", ctx.tagsArray);
          }
        },
        dependencies: [FilterComponent$1],
        encapsulation: 2
      });
    }
  }
  return FilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ForgotPasswordFormComponent = /*#__PURE__*/(() => {
  class ForgotPasswordFormComponent {
    constructor(customerService, alertMessageService, destroyRef) {
      this.customerService = customerService;
      this.alertMessageService = alertMessageService;
      this.destroyRef = destroyRef;
      this.emailLabel = 'Your email';
      this.emailPlaceholder = '';
      this.submitLabel = 'Sign In';
    }
    sendForgotPassword(customer) {
      this.customerService.forgotPassword$(customer.email).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.alertMessageService.sendMessage('You will receive an email to recover your password', 'success');
      }, error => {
        this.alertMessageService.sendMessage(error, 'danger');
      });
    }
    static {
      this.ɵfac = function ForgotPasswordFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ForgotPasswordFormComponent)(i0.ɵɵdirectiveInject(i1.CustomerService), i0.ɵɵdirectiveInject(i1.AlertMessageService), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ForgotPasswordFormComponent,
        selectors: [["ecommerce-forgot-password-form"]],
        inputs: {
          emailLabel: "emailLabel",
          emailPlaceholder: "emailPlaceholder",
          submitLabel: "submitLabel"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 3,
        consts: [[3, "forgotPasswordFormEvent", "emailLabel", "emailPlaceholder", "submitLabel"]],
        template: function ForgotPasswordFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cu-forgot-password-form", 0);
            i0.ɵɵlistener("forgotPasswordFormEvent", function ForgotPasswordFormComponent_Template_cu_forgot_password_form_forgotPasswordFormEvent_0_listener($event) {
              return ctx.sendForgotPassword($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("emailLabel", ctx.emailLabel)("emailPlaceholder", ctx.emailPlaceholder)("submitLabel", ctx.submitLabel);
          }
        },
        dependencies: [ForgotPasswordFormComponent$1],
        encapsulation: 2
      });
    }
  }
  return ForgotPasswordFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// FIXME: https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/688
let LanguageSelectorComponent = /*#__PURE__*/(() => {
  class LanguageSelectorComponent {
    constructor(_doc, formBuilder, languageSelectorService) {
      this._doc = _doc;
      this.formBuilder = formBuilder;
      this.languageSelectorService = languageSelectorService;
      this.languages = ['en', 'es'];
      this.siteLanguage = '';
      this.languageList = [{
        code: 'en',
        label: 'English'
      }, {
        code: 'es',
        label: 'Español'
      }];
      // TODO: bring lang from home view
      this.createLanguageSelectorForm();
    }
    ngOnInit() {
      this.siteLanguage = this.languageSelectorService.setSiteLanguage(this._doc);
      const siteLanguageExists = Object.values(this.languageList).some(language => language.code == this.siteLanguage);
      if (!siteLanguageExists) {
        this._doc.location.href = this.languageSelectorService.setLocation(this.languageList, this._doc);
      }
    }
    createLanguageSelectorForm() {
      this.languageSelectorForm = this.formBuilder.group({
        siteLanguage: ['']
      });
    }
    onLanguageChange(e) {
      this.siteLanguage = e.target.value;
      this._doc.location.href = this.languageSelectorService.updateLocation(this.siteLanguage, this._doc, this.siteLanguage);
    }
    static {
      this.ɵfac = function LanguageSelectorComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LanguageSelectorComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i1.LanguageSelectorService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LanguageSelectorComponent,
        selectors: [["ecommerce-language-selector"]],
        inputs: {
          languages: "languages"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 1,
        consts: [[3, "formGroup"], ["formControlName", "siteLanguage", 1, "form-select", "form-select-sm", 3, "change"], [3, "value"]],
        template: function LanguageSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div")(1, "form", 0)(2, "select", 1);
            i0.ɵɵlistener("change", function LanguageSelectorComponent_Template_select_change_2_listener($event) {
              return ctx.onLanguageChange($event);
            });
            i0.ɵɵrepeaterCreate(3, LanguageSelectorComponent_For_4_Template, 2, 2, "option", 2, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.languageSelectorForm);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.languages);
          }
        },
        dependencies: [ReactiveFormsModule, i1$1.ɵNgNoValidate, i1$1.NgSelectOption, i1$1.ɵNgSelectMultipleOption, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName],
        encapsulation: 2
      });
    }
  }
  return LanguageSelectorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginButtonComponent = /*#__PURE__*/(() => {
  class LoginButtonComponent {
    constructor(loginService, storeConfigService, customerService) {
      this.loginService = loginService;
      this.storeConfigService = storeConfigService;
      this.customerService = customerService;
      this.userName$ = new BehaviorSubject('');
      this.accountUrl = storeConfigService.getCustomRoutes()?.account ?? 'account';
      this.loginUrl = storeConfigService.getCustomRoutes()?.login ?? 'login';
      this.isLogged$ = this.loginService.isLogged();
      // FIXME: Instead subscribing to isLogged, we should subscribe correctly to the credentials observable in getCustomerUseCase.
      this.isLogged$.subscribe(state => {
        if (state) {
          this.customerService.getCustomer$().subscribe(customer => this.userName$.next(customer.userName || customer.firstName));
        }
      });
      this.userName = this.userName$;
    }
    static {
      this.ɵfac = function LoginButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginButtonComponent)(i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i2.StoreConfigService), i0.ɵɵdirectiveInject(i1.CustomerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginButtonComponent,
        selectors: [["ecommerce-login-button"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 4,
        consts: [[3, "isUserLoggedIn", "accountUrl", "loginUrl", "userName"]],
        template: function LoginButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cu-login-button", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("isUserLoggedIn", ctx.isLogged$)("accountUrl", ctx.accountUrl)("loginUrl", ctx.loginUrl)("userName", ctx.userName);
          }
        },
        dependencies: [LoginButtonComponent$1],
        encapsulation: 2
      });
    }
  }
  return LoginButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LoginFormComponent = /*#__PURE__*/(() => {
  class LoginFormComponent {
    constructor(loginService, alertMessageService, router, storeConfigService, customerService, destroyRef) {
      this.loginService = loginService;
      this.alertMessageService = alertMessageService;
      this.router = router;
      this.storeConfigService = storeConfigService;
      this.customerService = customerService;
      this.destroyRef = destroyRef;
      this.emailLabel = 'Your email';
      this.passwordLabel = 'Your password';
      this.emailPlaceholder = '';
      this.passwordPlaceholder = '';
      this.submitLabel = 'Sign In';
      this.forgotPasswordLabel = 'Forgot your password?';
      this.forgotPasswordUrl = storeConfigService.getCustomRoutes()?.forgotpassword ?? 'forgotpassword';
      /** @TODO This was a retrieving access token call for testing purposes, and may not need to be done here */
      this.customerService.tryGetCustomer$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
    /**
     * @deprecated This method should change and refer to the SAM loginUseCase
     * Be aware that the credentials token is already setted at this point from the loginM2M use case */
    login(customer) {
      this.loginService.login$(customer).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.router.navigateByUrl('/');
      }, () => {
        this.alertMessageService.sendMessage('Login Error', 'danger');
      });
    }
    static {
      this.ɵfac = function LoginFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LoginFormComponent)(i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i1.AlertMessageService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2.StoreConfigService), i0.ɵɵdirectiveInject(i1.CustomerService), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LoginFormComponent,
        selectors: [["ecommerce-login-form"]],
        inputs: {
          emailLabel: "emailLabel",
          passwordLabel: "passwordLabel",
          emailPlaceholder: "emailPlaceholder",
          passwordPlaceholder: "passwordPlaceholder",
          submitLabel: "submitLabel",
          forgotPasswordLabel: "forgotPasswordLabel"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 7,
        consts: [[3, "loginFormEvent", "forgotPasswordUrl", "emailLabel", "passwordLabel", "emailPlaceholder", "passwordPlaceholder", "submitLabel", "forgotPasswordLabel"]],
        template: function LoginFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cu-login-form", 0);
            i0.ɵɵlistener("loginFormEvent", function LoginFormComponent_Template_cu_login_form_loginFormEvent_0_listener($event) {
              return ctx.login($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("forgotPasswordUrl", ctx.forgotPasswordUrl)("emailLabel", ctx.emailLabel)("passwordLabel", ctx.passwordLabel)("emailPlaceholder", ctx.emailPlaceholder)("passwordPlaceholder", ctx.passwordPlaceholder)("submitLabel", ctx.submitLabel)("forgotPasswordLabel", ctx.forgotPasswordLabel);
          }
        },
        dependencies: [LoginFormComponent$1],
        encapsulation: 2
      });
    }
  }
  return LoginFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MainCarouselComponent = /*#__PURE__*/(() => {
  class MainCarouselComponent {
    constructor(legacyConfigService) {
      this.legacyConfigService = legacyConfigService;
      this.items$ = this.legacyConfigService.homeSlideshow$.pipe(map$1(carousel => carousel.items.filter(item => item.visible)));
      /**
       * We have to specify the height and width of the images to avoid layout shifts
       * the width & height will only affect the space the DOM will reserve for the image
       * once the image is loaded it will take the space it needs
       * If sizes is not defined it will assume it will take 100vw and it will probably download a much bigger image than needed
       * For more info got to --> https://angular.io/guide/image-directive
       */
      this.imgHeight = '388';
      this.imgWidth = '920';
      this.bullets = false;
      this.arrows = true;
    }
    static {
      this.ɵfac = function MainCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MainCarouselComponent)(i0.ɵɵdirectiveInject(i1.LegacyV4ConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MainCarouselComponent,
        selectors: [["ecommerce-main-carousel"]],
        inputs: {
          imgHeight: "imgHeight",
          imgWidth: "imgWidth",
          bullets: "bullets",
          arrows: "arrows"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 3,
        consts: [[1, "main-carousel"], ["type", "carousel", 1, "main-carousel__list", 3, "showBullets", "showArrows"], [1, "main-carousel__item"], ["ngSrcset", "200w, 400w, 600w, 800w, 1200w, 1600w, 1920w, 2560w", 1, "main-carousel__image", 3, "ngSrc", "alt", "height", "width", "priority", "loaderParams"], [1, "main-carousel__cta"], [1, "container-fluid"], [1, "display-4", "mb-4"], [1, "btn", "btn-primary", "btn-lg", 3, "routerLink"]],
        template: function MainCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MainCarouselComponent_Conditional_0_Template, 2, 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, MainCarouselComponent_Conditional_2_Template, 1, 0);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.items$)) ? 0 : 2, tmp_0_0);
          }
        },
        dependencies: [AsyncPipe, NgxGlideComponent, NgOptimizedImage, RouterLink],
        encapsulation: 2
      });
    }
  }
  return MainCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MaintenanceModule = /*#__PURE__*/(() => {
  class MaintenanceModule {
    static {
      this.ɵfac = function MaintenanceModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MaintenanceModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MaintenanceModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: MAINTENANCE_MODE_CONFIG,
          useFactory: maintenanceConfigService => maintenanceConfigService.get(),
          deps: [MaintenanceConfigService]
        }, {
          provide: DATE_NOW_FUNCTION,
          useValue: globalThis.Date.now
        }, MaintenanceService, MaintenanceConfigService]
      });
    }
  }
  return MaintenanceModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MinicartComponent = /*#__PURE__*/(() => {
  class MinicartComponent {
    constructor(cartService, legacyConfigService, destroyRef) {
      this.cartService = cartService;
      this.legacyConfigService = legacyConfigService;
      this.destroyRef = destroyRef;
      this.cartCount$ = EMPTY;
      this.cartTotal$ = EMPTY;
      this.currency$ = EMPTY;
      this.products$ = EMPTY;
      this.productsTillCartFull$ = EMPTY;
      this.showCartRemovalConfirmationModal = new EventEmitter();
      this.cartUrl = inject(StoreConfigService).getCustomRoutes()?.cart ?? 'cart';
      this.cartCount$ = this.cartService.getCount$();
      this.cartTotal$ = this.cartService.getTotal$();
      this.currency$ = this.legacyConfigService.currency$.pipe(map(curr => curr));
      this.products$ = this.cartService.cart$.pipe(map(items => items.products));
      this.productsTillCartFull$ = this.cartService.productsTillCartFull();
    }
    ngOnInit() {
      this.cartProductRemovalConfirmed.subscribe(cartProduct => {
        this.removeCartProduct(cartProduct);
      });
    }
    onUpdateCartData(cartProduct) {
      this.cartService.updateCart$(cartProduct).pipe(catchError(err => {
        console.log(err);
        return EMPTY;
      }), takeUntilDestroyed(this.destroyRef)).subscribe();
    }
    removeCartProduct(cartProduct) {
      this.cartService.removeFromCart$(cartProduct).pipe(catchError(err => {
        console.log(err);
        return EMPTY;
      }), takeUntilDestroyed(this.destroyRef)).subscribe();
    }
    onRemoveFromCartData(cartProduct) {
      this.showCartRemovalConfirmationModal.emit(cartProduct);
    }
    static {
      this.ɵfac = function MinicartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MinicartComponent)(i0.ɵɵdirectiveInject(i1.CartService), i0.ɵɵdirectiveInject(i1.LegacyV4ConfigService), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MinicartComponent,
        selectors: [["ecommerce-minicart"]],
        inputs: {
          cartProductRemovalConfirmed: "cartProductRemovalConfirmed"
        },
        outputs: {
          showCartRemovalConfirmationModal: "showCartRemovalConfirmationModal"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 6,
        vars: 16,
        consts: [[3, "removeFromCartData", "updateCartData", "cartUrl", "cartCount", "cartTotal", "currency", "products", "productsTillCartFull"]],
        template: function MinicartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "minicart", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵpipe(3, "async");
            i0.ɵɵpipe(4, "async");
            i0.ɵɵpipe(5, "async");
            i0.ɵɵlistener("removeFromCartData", function MinicartComponent_Template_minicart_removeFromCartData_0_listener($event) {
              return ctx.onRemoveFromCartData($event);
            })("updateCartData", function MinicartComponent_Template_minicart_updateCartData_0_listener($event) {
              return ctx.onUpdateCartData($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("cartUrl", ctx.cartUrl)("cartCount", i0.ɵɵpipeBind1(1, 6, ctx.cartCount$))("cartTotal", i0.ɵɵpipeBind1(2, 8, ctx.cartTotal$))("currency", i0.ɵɵpipeBind1(3, 10, ctx.currency$))("products", i0.ɵɵpipeBind1(4, 12, ctx.products$))("productsTillCartFull", i0.ɵɵpipeBind1(5, 14, ctx.productsTillCartFull$));
          }
        },
        dependencies: [MinicartComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return MinicartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductAddedToCartComponent = /*#__PURE__*/(() => {
  class ProductAddedToCartComponent {
    constructor(productAddedToCartService, cartService) {
      this.productAddedToCartService = productAddedToCartService;
      this.cartService = cartService;
      this.quantity = 1;
      this.formCloseEvent = new EventEmitter();
      this.openAddedToCartModalEvent = new EventEmitter();
      this.cartUrl = inject(StoreConfigService).getCustomRoutes()?.cart ?? 'cart';
    }
    get productTitle() {
      return this.productAddedToCartService.getProductTitle(this.product);
    }
    closeAddedToCartModalEvent() {
      this.formCloseEvent.emit();
    }
    openModalEvent() {
      this.openAddedToCartModalEvent.emit();
    }
    static {
      this.ɵfac = function ProductAddedToCartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductAddedToCartComponent)(i0.ɵɵdirectiveInject(i1.ProductAddedToCartService), i0.ɵɵdirectiveInject(i1.CartService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductAddedToCartComponent,
        selectors: [["ecommerce-product-added-to-cart"]],
        inputs: {
          product: "product",
          quantity: "quantity"
        },
        outputs: {
          formCloseEvent: "formCloseEvent",
          openAddedToCartModalEvent: "openAddedToCartModalEvent"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 5,
        consts: [[3, "closeModalEvent", "addedToCartEvent", "product", "productPrice", "productStock", "quantity", "cartUrl"]],
        template: function ProductAddedToCartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "pr-added-to-cart", 0);
            i0.ɵɵlistener("closeModalEvent", function ProductAddedToCartComponent_Template_pr_added_to_cart_closeModalEvent_0_listener() {
              return ctx.closeAddedToCartModalEvent();
            })("addedToCartEvent", function ProductAddedToCartComponent_Template_pr_added_to_cart_addedToCartEvent_0_listener() {
              return ctx.openModalEvent();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("product", ctx.product)("productPrice", ctx.product == null ? null : ctx.product.price)("productStock", ctx.product == null ? null : ctx.product.stock)("quantity", ctx.quantity)("cartUrl", ctx.cartUrl);
          }
        },
        dependencies: [ProductAddedToCartComponent$1],
        encapsulation: 2
      });
    }
  }
  return ProductAddedToCartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductCarouselComponent = /*#__PURE__*/(() => {
  class ProductCarouselComponent {
    constructor(productCarouselService) {
      this.productCarouselService = productCarouselService;
      this.title = '';
      this.feedId = 0;
      this.type = 'related';
      this.storeSearchResults$ = EMPTY;
    }
    ngOnInit() {
      this.storeSearchResults$ = this.productCarouselService.getFeedProductsEvent(this.feedId);
    }
    static {
      this.ɵfac = function ProductCarouselComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductCarouselComponent)(i0.ɵɵdirectiveInject(i1.ProductCarouselService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductCarouselComponent,
        selectors: [["ecommerce-product-carousel"]],
        inputs: {
          title: "title",
          feedId: "feedId",
          type: "type"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "title", "productList"]],
        template: function ProductCarouselComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ProductCarouselComponent_Conditional_0_Template, 1, 1);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = i0.ɵɵpipeBind1(1, 1, ctx.storeSearchResults$)) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [ProductCarouselComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return ProductCarouselComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductDescriptionAccordionComponent = /*#__PURE__*/(() => {
  class ProductDescriptionAccordionComponent {
    set product(product) {
      if (!product.descriptions || product.descriptions.length === 0) {
        return;
      }
      const productDescription = product.descriptions.find(d => d.lang === this.locale) || product.descriptions[0];
      if (!productDescription.sections || productDescription.sections.length === 0) {
        return;
      }
      this.sections = productDescription.sections.map(section => ({
        ...section,
        title: section.title || this.dynamicTitles[`${section.i18nTitleTag}`]
      }));
    }
    constructor(locale) {
      this.locale = locale;
      this.dynamicTitles = {
        'PRODUCTS.DESCRIPTION': '',
        'PRODUCTS.FEATURES': ''
      };
      this.sections = [];
    }
    static {
      this.ɵfac = function ProductDescriptionAccordionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductDescriptionAccordionComponent)(i0.ɵɵdirectiveInject(LOCALE_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductDescriptionAccordionComponent,
        selectors: [["ecommerce-product-description-accordion"]],
        inputs: {
          product: "product",
          dynamicTitles: "dynamicTitles"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "sections"]],
        template: function ProductDescriptionAccordionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cm-accordion", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("sections", ctx.sections);
          }
        },
        dependencies: [AccordionComponent],
        encapsulation: 2
      });
    }
  }
  return ProductDescriptionAccordionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcommerceProductDescriptionTabsComponent = /*#__PURE__*/(() => {
  class EcommerceProductDescriptionTabsComponent {
    set product(product) {
      if (!product.descriptions || product.descriptions.length === 0) {
        return;
      }
      const productDescription = product.descriptions.find(d => this.locale.includes(d.lang)) || product.descriptions[0];
      if (!productDescription.sections || productDescription.sections.length === 0) {
        return;
      }
      this.sections = productDescription.sections.map(section => ({
        ...section,
        title: section.title || this.dynamicTitles[`${section.i18nTitleTag}`]
      }));
    }
    constructor(locale) {
      this.locale = locale;
      this.dynamicTitles = {
        'PRODUCTS.DESCRIPTION': '',
        'PRODUCTS.FEATURES': ''
      };
      this.sections = [];
    }
    static {
      this.ɵfac = function EcommerceProductDescriptionTabsComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcommerceProductDescriptionTabsComponent)(i0.ɵɵdirectiveInject(LOCALE_ID));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcommerceProductDescriptionTabsComponent,
        selectors: [["ecommerce-product-description-tabs"]],
        inputs: {
          dynamicTitles: "dynamicTitles",
          product: "product"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "sections"]],
        template: function EcommerceProductDescriptionTabsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "pr-product-description-tabs", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("sections", ctx.sections);
          }
        },
        dependencies: [ProductDescriptionTabsComponent],
        encapsulation: 2
      });
    }
  }
  return EcommerceProductDescriptionTabsComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductGalleryComponent = /*#__PURE__*/(() => {
  class ProductGalleryComponent {
    constructor(productGalleryService) {
      this.productGalleryService = productGalleryService;
      this.productId = '';
    }
    ngOnInit() {
      this.items$ = this.productGalleryService.getGallery$(this.productId);
    }
    static {
      this.ɵfac = function ProductGalleryComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductGalleryComponent)(i0.ɵɵdirectiveInject(i1.ProductGalleryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductGalleryComponent,
        selectors: [["ecommerce-product-gallery"]],
        inputs: {
          productId: "productId"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "galleryItems"]],
        template: function ProductGalleryComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "pr-product-gallery", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("galleryItems", i0.ɵɵpipeBind1(1, 1, ctx.items$));
          }
        },
        dependencies: [ProductGalleryComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return ProductGalleryComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductPriceComponent = /*#__PURE__*/(() => {
  class ProductPriceComponent {
    constructor(productPriceService) {
      this.productPriceService = productPriceService;
      this.productId = '';
      this.showDiscounted = true;
    }
    ngOnInit() {
      this.productPrice$ = this.productPriceService.getPrice$(this.productId);
    }
    static {
      this.ɵfac = function ProductPriceComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductPriceComponent)(i0.ɵɵdirectiveInject(i1.ProductPriceService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductPriceComponent,
        selectors: [["ecommerce-product-price"]],
        inputs: {
          productId: "productId",
          showDiscounted: "showDiscounted"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 4,
        consts: [[3, "productPriceInfo", "showDiscounted"]],
        template: function ProductPriceComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cm-product-price", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("productPriceInfo", i0.ɵɵpipeBind1(1, 2, ctx.productPrice$))("showDiscounted", ctx.showDiscounted);
          }
        },
        dependencies: [ProductPriceComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return ProductPriceComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductShortDescriptionComponent = /*#__PURE__*/(() => {
  class ProductShortDescriptionComponent {
    constructor(locale, productShortDescriptionService) {
      this.locale = locale;
      this.productShortDescriptionService = productShortDescriptionService;
      this.productId = '';
      this.shortDesciption$ = of('');
    }
    ngOnInit() {
      this.shortDesciption$ = this.productShortDescriptionService.getShortDesc$(this.productId, this.locale);
    }
    static {
      this.ɵfac = function ProductShortDescriptionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductShortDescriptionComponent)(i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(i1.ProductShortDescriptionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductShortDescriptionComponent,
        selectors: [["ecommerce-product-short-description"]],
        inputs: {
          productId: "productId"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 3,
        template: function ProductShortDescriptionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "span");
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, ctx.shortDesciption$));
          }
        },
        dependencies: [AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return ProductShortDescriptionComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProductTitleComponent = /*#__PURE__*/(() => {
  class ProductTitleComponent {
    constructor(locale, productTitleService) {
      this.locale = locale;
      this.productTitleService = productTitleService;
      this.productId = '';
      this.title$ = of('');
    }
    ngOnInit() {
      this.title$ = this.productTitleService.getTitle$(this.productId, this.locale);
    }
    static {
      this.ɵfac = function ProductTitleComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ProductTitleComponent)(i0.ɵɵdirectiveInject(LOCALE_ID), i0.ɵɵdirectiveInject(i1.ProductTitleService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ProductTitleComponent,
        selectors: [["ecommerce-product-title"]],
        inputs: {
          productId: "productId"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 3,
        consts: [[3, "title"]],
        template: function ProductTitleComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "pr-product-title", 0);
            i0.ɵɵpipe(1, "async");
          }
          if (rf & 2) {
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(1, 1, ctx.title$));
          }
        },
        dependencies: [ProductTitleComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return ProductTitleComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RegisterFormComponent = /*#__PURE__*/(() => {
  class RegisterFormComponent {
    constructor(legacyConfigService, storeService, loginService, alertMessageService, customerService, router, destroyRef) {
      this.legacyConfigService = legacyConfigService;
      this.storeService = storeService;
      this.loginService = loginService;
      this.alertMessageService = alertMessageService;
      this.customerService = customerService;
      this.router = router;
      this.destroyRef = destroyRef;
      this.genderLabel = 'Gender';
      this.genderPlaceholder = 'Select an option';
      this.firstNameLabel = 'First Name';
      this.firstNamePlaceholder = '';
      this.lastNameLabel = 'Last Name';
      this.lastNamePlaceholder = '';
      this.emailLabel = 'Your email';
      this.emailPlaceholder = '';
      this.confirmEmailLabel = 'Confirm Email';
      this.passwordLabel = 'Password';
      this.confirmPasswordLabel = 'Confirm Password';
      this.submitLabel = 'Sign Up';
      this.dateOfBirthLabel = 'Date of Birth';
      this.dayOfBirthPlaceholder = 'Day';
      this.monthOfBirthPlaceholder = 'Month';
      this.yearOfBirthPlaceholder = 'Year';
      this.countryLabel = 'Country';
      this.countryPlaceholder = 'Select a country';
      this.newsletterText = '';
      this.newsletterSecondaryText = '';
      this.promotionsText = '';
      this.termsAndConditionsText = '';
      this.hasNewsletter$ = this.storeService.hasNewsletter$.pipe(map(hasNewsletter => hasNewsletter));
      this.hasPromotions$ = this.legacyConfigService.hasPromotions$.pipe(map(hasPromotions => hasPromotions));
      this.registerCustomerSubscription = new Subscription();
      this.loginSubscription = new Subscription();
      this.hasNewsletterSubscription = new Subscription();
      this.hasPromotionsSubscription = new Subscription();
    }
    ngOnInit() {
      this.hasNewsletterSubscription = this.hasNewsletter$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasNewsletter => this.hasNewsletter = hasNewsletter);
      this.hasPromotionsSubscription = this.hasPromotions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(hasPromotions => this.hasPromotions = hasPromotions);
    }
    ngOnDestroy() {
      this.registerCustomerSubscription.unsubscribe();
      this.loginSubscription.unsubscribe();
      this.hasNewsletterSubscription.unsubscribe();
      this.hasPromotionsSubscription.unsubscribe();
    }
    register(customerData) {
      !this.hasNewsletter ? delete customerData.customer.newsletter : '';
      !this.hasPromotions ? delete customerData.customer.promotions : '';
      this.registerCustomerSubscription = this.customerService.registerCustomer$(customerData.customer, customerData.password).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        if (data.customerId) {
          this.login({
            email: customerData.customer.email,
            password: customerData.password
          });
        }
      }, error => {
        this.alertMessageService.sendMessage(error.message, 'danger');
      });
    }
    /**
     * @deprecated This method should change and refer to the SAM registerUseCase
     * Be aware that the credentials token is already setted at this point from the loginM2M use case */
    login(customer) {
      this.loginSubscription = this.loginService.login$(customer).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.router.navigateByUrl('/');
      }, () => {
        this.alertMessageService.sendMessage('Login Error', 'danger');
      });
    }
    static {
      this.ɵfac = function RegisterFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RegisterFormComponent)(i0.ɵɵdirectiveInject(i1.LegacyV4ConfigService), i0.ɵɵdirectiveInject(i1.StoreService), i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i1.AlertMessageService), i0.ɵɵdirectiveInject(i1.CustomerService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RegisterFormComponent,
        selectors: [["ecommerce-register-form"]],
        inputs: {
          genderLabel: "genderLabel",
          genderPlaceholder: "genderPlaceholder",
          firstNameLabel: "firstNameLabel",
          firstNamePlaceholder: "firstNamePlaceholder",
          lastNameLabel: "lastNameLabel",
          lastNamePlaceholder: "lastNamePlaceholder",
          emailLabel: "emailLabel",
          emailPlaceholder: "emailPlaceholder",
          confirmEmailLabel: "confirmEmailLabel",
          passwordLabel: "passwordLabel",
          confirmPasswordLabel: "confirmPasswordLabel",
          submitLabel: "submitLabel",
          dateOfBirthLabel: "dateOfBirthLabel",
          dayOfBirthPlaceholder: "dayOfBirthPlaceholder",
          monthOfBirthPlaceholder: "monthOfBirthPlaceholder",
          yearOfBirthPlaceholder: "yearOfBirthPlaceholder",
          countryLabel: "countryLabel",
          countryPlaceholder: "countryPlaceholder",
          newsletterText: "newsletterText",
          newsletterSecondaryText: "newsletterSecondaryText",
          promotionsText: "promotionsText",
          termsAndConditionsText: "termsAndConditionsText"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 28,
        consts: [[3, "registerFormEvent", "genderLabel", "genderPlaceholder", "firstNameLabel", "firstNamePlaceholder", "lastNameLabel", "lastNamePlaceholder", "emailLabel", "passwordLabel", "confirmPasswordLabel", "emailPlaceholder", "confirmEmailLabel", "submitLabel", "dateOfBirthLabel", "dayOfBirthPlaceholder", "monthOfBirthPlaceholder", "yearOfBirthPlaceholder", "countryLabel", "countryPlaceholder", "hasNewsletter", "newsletterText", "newsletterSecondaryText", "hasPromotions", "promotionsText", "termsAndConditionsText"]],
        template: function RegisterFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cu-register-form", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵpipe(2, "async");
            i0.ɵɵlistener("registerFormEvent", function RegisterFormComponent_Template_cu_register_form_registerFormEvent_0_listener($event) {
              return ctx.register($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("genderLabel", ctx.genderLabel)("genderPlaceholder", ctx.genderPlaceholder)("firstNameLabel", ctx.firstNameLabel)("firstNamePlaceholder", ctx.firstNamePlaceholder)("lastNameLabel", ctx.lastNameLabel)("lastNamePlaceholder", ctx.lastNamePlaceholder)("emailLabel", ctx.emailLabel)("passwordLabel", ctx.passwordLabel)("confirmPasswordLabel", ctx.confirmPasswordLabel)("emailPlaceholder", ctx.emailPlaceholder)("confirmEmailLabel", ctx.confirmEmailLabel)("submitLabel", ctx.submitLabel)("dateOfBirthLabel", ctx.dateOfBirthLabel)("dayOfBirthPlaceholder", ctx.dayOfBirthPlaceholder)("monthOfBirthPlaceholder", ctx.monthOfBirthPlaceholder)("yearOfBirthPlaceholder", ctx.yearOfBirthPlaceholder)("countryLabel", ctx.countryLabel)("countryPlaceholder", ctx.countryPlaceholder)("hasNewsletter", i0.ɵɵpipeBind1(1, 24, ctx.hasNewsletter$))("newsletterText", ctx.newsletterText)("newsletterSecondaryText", ctx.newsletterSecondaryText)("hasPromotions", i0.ɵɵpipeBind1(2, 26, ctx.hasPromotions$))("promotionsText", ctx.promotionsText)("termsAndConditionsText", ctx.termsAndConditionsText);
          }
        },
        dependencies: [RegisterFormComponent$1, AsyncPipe],
        encapsulation: 2
      });
    }
  }
  return RegisterFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RemoveProductFromCartComponent = /*#__PURE__*/(() => {
  class RemoveProductFromCartComponent {
    constructor() {
      this.closeRemoveProductModalEvent = new EventEmitter();
      this.cartProductRemovalConfirmationEvent = new EventEmitter();
    }
    cartProductRemovalConfirmation() {
      this.cartProductRemovalConfirmationEvent.emit();
    }
    closeRemoveProductModal() {
      this.closeRemoveProductModalEvent.emit();
    }
    static {
      this.ɵfac = function RemoveProductFromCartComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RemoveProductFromCartComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RemoveProductFromCartComponent,
        selectors: [["ecommerce-remove-product-from-cart"]],
        outputs: {
          closeRemoveProductModalEvent: "closeRemoveProductModalEvent",
          cartProductRemovalConfirmationEvent: "cartProductRemovalConfirmationEvent"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 0,
        consts: [[3, "closeModalEvent", "cartProductRemovalEvent"]],
        template: function RemoveProductFromCartComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "remove-product-from-cart", 0);
            i0.ɵɵlistener("closeModalEvent", function RemoveProductFromCartComponent_Template_remove_product_from_cart_closeModalEvent_0_listener() {
              return ctx.closeRemoveProductModal();
            })("cartProductRemovalEvent", function RemoveProductFromCartComponent_Template_remove_product_from_cart_cartProductRemovalEvent_0_listener() {
              return ctx.cartProductRemovalConfirmation();
            });
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [RemoveProductFromCartComponent$1],
        encapsulation: 2
      });
    }
  }
  return RemoveProductFromCartComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ResetPasswordFormComponent = /*#__PURE__*/(() => {
  class ResetPasswordFormComponent {
    constructor(customerService, alertMessageService, router, activatedRoute, destroyRef) {
      this.customerService = customerService;
      this.alertMessageService = alertMessageService;
      this.router = router;
      this.activatedRoute = activatedRoute;
      this.destroyRef = destroyRef;
      this.passwordLabel = 'New Password';
      this.passwordPlaceholder = '';
      this.confirmPasswordLabel = 'Confirm Password';
      this.submitLabel = 'Modify password';
      this.token = '';
      this.customerId = '';
      this.activatedRoute.queryParams.subscribe(params => {
        this.token = params['token'];
        this.customerId = params['customerID'];
      });
    }
    sendResetPassword(customer) {
      if (!this.token || !this.customerId) {
        this.alertMessageService.sendMessage('Invalid token', 'danger');
        return;
      }
      this.customerService.resetPassword$(this.customerId, customer.password, this.token).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.router.navigateByUrl('/login');
        this.alertMessageService.sendMessage('Password modified', 'success');
      }, error => {
        this.alertMessageService.sendMessage(error, 'danger');
      });
    }
    static {
      this.ɵfac = function ResetPasswordFormComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ResetPasswordFormComponent)(i0.ɵɵdirectiveInject(i1.CustomerService), i0.ɵɵdirectiveInject(i1.AlertMessageService), i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i2$1.ActivatedRoute), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ResetPasswordFormComponent,
        selectors: [["ecommerce-reset-password-form"]],
        inputs: {
          passwordLabel: "passwordLabel",
          passwordPlaceholder: "passwordPlaceholder",
          confirmPasswordLabel: "confirmPasswordLabel",
          submitLabel: "submitLabel"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 4,
        consts: [[3, "resetPasswordFormEvent", "passwordLabel", "passwordPlaceholder", "confirmPasswordLabel", "submitLabel"]],
        template: function ResetPasswordFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cu-reset-password-form", 0);
            i0.ɵɵlistener("resetPasswordFormEvent", function ResetPasswordFormComponent_Template_cu_reset_password_form_resetPasswordFormEvent_0_listener($event) {
              return ctx.sendResetPassword($event);
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("passwordLabel", ctx.passwordLabel)("passwordPlaceholder", ctx.passwordPlaceholder)("confirmPasswordLabel", ctx.confirmPasswordLabel)("submitLabel", ctx.submitLabel);
          }
        },
        dependencies: [ResetPasswordFormComponent$1],
        encapsulation: 2
      });
    }
  }
  return ResetPasswordFormComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchBarComponent = /*#__PURE__*/(() => {
  class SearchBarComponent {
    constructor(searchBarService, destroyRef) {
      this.searchBarService = searchBarService;
      this.destroyRef = destroyRef;
      this.searchResults = [];
      this.isActiveSearch = false;
      this.isMobile = true;
      this.searchForm = new FormGroup({
        search: new FormControl()
      });
      this.filter = this.searchBarService.getFilter();
      this.searchBarService.searchBarEvents$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
        this.searchResults = data.products;
        this.filter = this.searchBarService.getFilter();
        this.isActiveSearch = true;
      });
    }
    onSearchFormChange(keyword) {
      this.searchBarService.pushSearchBarEvent(keyword);
    }
    resetSearchFilters() {
      this.searchBarService.setFilter('search', [], '');
      this.filter = this.searchBarService.getFilter();
      this.isActiveSearch = false;
      this.searchResults = [];
    }
    showSearchResultsPage(searchCriteria) {
      this.searchBarService.navigateToSearchPage(searchCriteria);
    }
    triggerOpenSearchBarMobileContainer() {
      asapScheduler.schedule(() => {
        this.isMobile = !this.isMobile;
      }, 1000);
    }
    onFocusOut() {
      asapScheduler.schedule(() => {
        this.searchForm.reset();
        this.emitResetFilters();
      }, 1000);
    }
    emitSearchFormChanges() {
      this.onSearchFormChange(this.searchForm.value);
    }
    emitResetFilters() {
      this.resetSearchFilters();
    }
    emitGoToSearchResultsPage(searchCriteria) {
      // If the search results page it's empty we don't do anything
      if (!searchCriteria) {
        return;
      }
      this.showSearchResultsPage(searchCriteria);
    }
    emitTriggerSearchBarMobile() {
      this.triggerOpenSearchBarMobileContainer();
    }
    static {
      this.ɵfac = function SearchBarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SearchBarComponent)(i0.ɵɵdirectiveInject(i1.SearchBarService), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchBarComponent,
        selectors: [["ecommerce-search-bar"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 28,
        vars: 16,
        consts: [["searchBarDesktop", ""], ["searchBarMobile", ""], [1, "search-bar-container", "d-flex"], ["role", "search", "aria-label", "search bar form", 1, "search-bar-form", "d-flex", "d-none", "d-sm-block", 3, "focusout", "formGroup"], [1, "input-group"], ["type", "text", "placeholder", "Search", "aria-label", "Search", "formControlName", "search", 1, "form-control", "form-control-sm", 3, "keyup", "keyup.enter"], [1, "input-group-append"], [1, "btn-group"], ["type", "button", 3, "ngClass"], [1, "bi", "bi-x"], [1, "btn", "btn-sm", "btn-outline-secondary", "search-button", 3, "click"], [1, "bi", "bi-search"], [1, "input-group-append", "d-flex", "d-block", "d-sm-none"], ["type", "button", 1, "btn", "btn-outline-secondary", "search-button-mobile", 3, "click"], ["role", "search", "aria-label", "search bar form mobile", 3, "focusout", "ngClass", "formGroup"], [1, "input-group-text"], ["type", "button", 1, "search-bar__close-button", 3, "click"], [1, "bi", "bi-arrow-left"], ["type", "text", "placeholder", "Search", "aria-label", "Search", "formControlName", "search", 1, "form-control", 3, "keyup", "keyup.enter"], ["type", "button", 1, "search-button-mobile", 3, "click"], [3, "isActiveSearch", "searchResults"]],
        template: function SearchBarComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "form", 3);
            i0.ɵɵlistener("focusout", function SearchBarComponent_Template_form_focusout_1_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusOut());
            });
            i0.ɵɵelementStart(2, "div", 4)(3, "input", 5, 0);
            i0.ɵɵlistener("keyup", function SearchBarComponent_Template_input_keyup_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitSearchFormChanges());
            })("keyup.enter", function SearchBarComponent_Template_input_keyup_enter_3_listener() {
              i0.ɵɵrestoreView(_r1);
              const searchBarDesktop_r2 = i0.ɵɵreference(4);
              return i0.ɵɵresetView(ctx.emitGoToSearchResultsPage(searchBarDesktop_r2.value));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 6)(6, "div", 7)(7, "button", 8);
            i0.ɵɵelement(8, "i", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "div", 10);
            i0.ɵɵlistener("click", function SearchBarComponent_Template_div_click_9_listener() {
              i0.ɵɵrestoreView(_r1);
              const searchBarDesktop_r2 = i0.ɵɵreference(4);
              return i0.ɵɵresetView(ctx.emitGoToSearchResultsPage(searchBarDesktop_r2.value));
            });
            i0.ɵɵelement(10, "i", 11);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelementStart(11, "div", 12)(12, "button", 13);
            i0.ɵɵlistener("click", function SearchBarComponent_Template_button_click_12_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitTriggerSearchBarMobile());
            });
            i0.ɵɵelement(13, "i", 11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(14, "form", 14);
            i0.ɵɵlistener("focusout", function SearchBarComponent_Template_form_focusout_14_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onFocusOut());
            });
            i0.ɵɵelementStart(15, "div", 4)(16, "span", 15)(17, "button", 16);
            i0.ɵɵlistener("click", function SearchBarComponent_Template_button_click_17_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitTriggerSearchBarMobile());
            });
            i0.ɵɵelement(18, "i", 17);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(19, "input", 18, 1);
            i0.ɵɵlistener("keyup", function SearchBarComponent_Template_input_keyup_19_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.emitSearchFormChanges());
            })("keyup.enter", function SearchBarComponent_Template_input_keyup_enter_19_listener() {
              i0.ɵɵrestoreView(_r1);
              const searchBarMobile_r3 = i0.ɵɵreference(20);
              return i0.ɵɵresetView(ctx.emitGoToSearchResultsPage(searchBarMobile_r3.value));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(21, "span", 15)(22, "button", 8);
            i0.ɵɵelement(23, "i", 9);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "span", 15)(25, "button", 19);
            i0.ɵɵlistener("click", function SearchBarComponent_Template_button_click_25_listener() {
              i0.ɵɵrestoreView(_r1);
              const searchBarMobile_r3 = i0.ɵɵreference(20);
              return i0.ɵɵresetView(ctx.emitGoToSearchResultsPage(searchBarMobile_r3.value));
            });
            i0.ɵɵelement(26, "i", 11);
            i0.ɵɵelementEnd()()()()();
            i0.ɵɵelement(27, "cm-search-bar-results", 20);
          }
          if (rf & 2) {
            const searchBarDesktop_r2 = i0.ɵɵreference(4);
            const searchBarMobile_r3 = i0.ɵɵreference(20);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formGroup", ctx.searchForm);
            i0.ɵɵadvance(6);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c2, !searchBarDesktop_r2.value, searchBarDesktop_r2.value));
            i0.ɵɵadvance(7);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c3, ctx.isMobile, !ctx.isMobile))("formGroup", ctx.searchForm);
            i0.ɵɵadvance(8);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(13, _c4, !searchBarMobile_r3.value, searchBarMobile_r3.value));
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("isActiveSearch", ctx.isActiveSearch)("searchResults", ctx.searchResults);
          }
        },
        dependencies: [ReactiveFormsModule, i1$1.ɵNgNoValidate, i1$1.DefaultValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.FormControlName, NgClass, SearchBarResultsComponent],
        encapsulation: 2
      });
    }
  }
  return SearchBarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SearchFilterComponent = /*#__PURE__*/(() => {
  class SearchFilterComponent {
    constructor() {
      this.filterService = inject(SearchResultsPageService);
      this.tagsArray = [];
      this.filtersCriteria = this.filterService.loadFiltersCriteria();
    }
    ngOnInit() {
      this.filtersCriteria = this.filterService.removeExcludedFilters(this.filtersCriteria, this.categoryId);
    }
    filterChange(event) {
      const filters = CategoryPageCriteriaFiltersAdapter.buildPartialFiltersFromMultiSelect(event);
      this.filterService.setFilters(filters);
    }
    removeTagEvent(event) {
      this.filtersCriteria = this.filterService.updateFilterChangedInLoadCriterial(event, this.filtersCriteria);
      const filters = CategoryPageCriteriaFiltersAdapter.buildPartialFiltersFromMultiSelect(event);
      this.filterService.setFilters(filters);
    }
    resetFilters() {
      const emptyFilters = {
        offset: 1,
        pageSize: 12,
        filters: Array(0)
      };
      this.filtersCriteria = this.filterService.resetFilters();
      this.filterService.setFilters(emptyFilters);
    }
    createTagEvent(event) {
      const {
        tagList,
        filter
      } = event;
      this.tagsArray = [JSON.parse(JSON.stringify(this.filterService.createFilterTag(tagList, filter)))];
    }
    static {
      this.ɵfac = function SearchFilterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SearchFilterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SearchFilterComponent,
        selectors: [["ecommerce-search-filter"]],
        inputs: {
          categoryId: "categoryId"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "filterEvent", "removeFilterTagEvent", "createFilterTagEvent", "removeAllTagsEvent", "filters", "tagsArray"]],
        template: function SearchFilterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "cm-filter", 0);
            i0.ɵɵlistener("filterEvent", function SearchFilterComponent_Template_cm_filter_filterEvent_0_listener($event) {
              return ctx.filterChange($event);
            })("removeFilterTagEvent", function SearchFilterComponent_Template_cm_filter_removeFilterTagEvent_0_listener($event) {
              return ctx.removeTagEvent($event);
            })("createFilterTagEvent", function SearchFilterComponent_Template_cm_filter_createFilterTagEvent_0_listener($event) {
              return ctx.createTagEvent($event);
            })("removeAllTagsEvent", function SearchFilterComponent_Template_cm_filter_removeAllTagsEvent_0_listener() {
              return ctx.resetFilters();
            });
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("filters", ctx.filtersCriteria)("tagsArray", ctx.tagsArray);
          }
        },
        dependencies: [FilterComponent$1],
        encapsulation: 2
      });
    }
  }
  return SearchFilterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SpinnerComponent = /*#__PURE__*/(() => {
  class SpinnerComponent {
    constructor(spinnerService) {
      this.spinnerService = spinnerService;
    }
    get isLoading() {
      return this.spinnerService.getLoading();
    }
    static {
      this.ɵfac = function SpinnerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SpinnerComponent)(i0.ɵɵdirectiveInject(i1.SpinnerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SpinnerComponent,
        selectors: [["ecommerce-spinner"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "isLoading"]],
        template: function SpinnerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "cmp-spinner", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("isLoading", ctx.isLoading);
          }
        },
        dependencies: [SpinnerComponent$1],
        encapsulation: 2
      });
    }
  }
  return SpinnerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// FIXME: https://setnext.scalefast.ninja/scalefast/frontend/pandora/-/issues/688
let DesktopNavComponent = /*#__PURE__*/(() => {
  class DesktopNavComponent {
    static {
      this.ɵfac = function DesktopNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DesktopNavComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DesktopNavComponent,
        selectors: [["ecommerce-desktop-nav"]],
        inputs: {
          items: "items"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 0,
        consts: [[1, "navigation", "navigation__desktop", "border-top"], [1, "navigation__list"], [1, "navigation__list-item"], [1, "navigation__list-item-link", 3, "routerLink"], [1, "navigation__list-dropdown", "pb-4", "pt-4"], [1, "navigation__list-item", "navigation__list-item--second-level"], [1, "navigation__list-child"], [1, "navigation__list-item", "navigation__list-item--third-level"]],
        template: function DesktopNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "nav", 0)(1, "ul", 1);
            i0.ɵɵrepeaterCreate(2, DesktopNavComponent_For_3_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.items);
          }
        },
        dependencies: [RouterLink],
        encapsulation: 2
      });
    }
  }
  return DesktopNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcommerceStoreNavDropdownLinksComponent = /*#__PURE__*/(() => {
  class EcommerceStoreNavDropdownLinksComponent {
    constructor() {
      this.clickMenuItem = new EventEmitter();
      this.dropdownOpen = signal(-1);
      this.visibleItems = signal([]);
    }
    ngOnInit() {
      if (this.item.childLinks) {
        this.visibleItems.set(this.item.childLinks.filter(child => !child.hidden).slice(0, 4));
      }
    }
    clickItem() {
      this.clickMenuItem.emit({
        event: 'APP_MENU_CLICK',
        status: false
      });
    }
    openDropdown(index) {
      this.dropdownOpen.set(index);
    }
    toggleDropdown(index) {
      this.dropdownOpen.update(i => i === index ? -1 : index);
    }
    closeDropdown() {
      this.dropdownOpen.set(-1);
    }
    static {
      this.ɵfac = function EcommerceStoreNavDropdownLinksComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcommerceStoreNavDropdownLinksComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcommerceStoreNavDropdownLinksComponent,
        selectors: [["ecommerce-store-nav-dropdown-links"]],
        inputs: {
          item: "item",
          isVisible: "isVisible"
        },
        outputs: {
          clickMenuItem: "clickMenuItem"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 0,
        consts: () => {
          let i18n_2;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_2 = goog.getMsg("See all");
            i18n_2 = MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_2;
          } else {
            i18n_2 = $localize`:@@SEE_ALL:See all`;
          }
          return [["StoreNavLinkTitle", ""], i18n_2, [1, "navigation__list-dropdown", "links-menu"], [1, "navigation__list-item", "navigation__list-item--second-level", "col-12", 3, "ngClass"], [1, "navigation__list-item-link", 3, "routerLink"], ["type", "button", 1, "navigation__list-item-link", "navigation__list-item-button", 3, "click"], [4, "ngTemplateOutlet"], [1, "navigation__list", "list-unstyled", 3, "ngClass"], [1, "navigation__list-item--see-all"], [1, "navigation__list-item--third-level"], [3, "click", "routerLink"], [3, "innerHTML"], [1, "circle-arrow-before"], [1, "navigation__list-item-title", 3, "innerHtml"]];
        },
        template: function EcommerceStoreNavDropdownLinksComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 2);
            i0.ɵɵrepeaterCreate(1, EcommerceStoreNavDropdownLinksComponent_For_2_Template, 5, 6, "li", 3, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.visibleItems());
          }
        },
        dependencies: [NgClass, NgTemplateOutlet, RouterModule, i2$1.RouterLink],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return EcommerceStoreNavDropdownLinksComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EcommerceStoreNavDropdownComponent = /*#__PURE__*/(() => {
  class EcommerceStoreNavDropdownComponent {
    constructor() {
      this.clickMenuItem = new EventEmitter();
      this.linksMenu = false;
    }
    ngOnInit() {
      this.linksMenu = this.item.dropdownStyle === 'links' ? true : false;
    }
    clickItem() {
      this.clickMenuItem.emit({
        event: 'APP_MENU_CLICK',
        status: false
      });
    }
    static {
      this.ɵfac = function EcommerceStoreNavDropdownComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || EcommerceStoreNavDropdownComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EcommerceStoreNavDropdownComponent,
        selectors: [["ecommerce-store-nav-dropdown"]],
        inputs: {
          item: "item",
          isVisible: "isVisible"
        },
        outputs: {
          clickMenuItem: "clickMenuItem"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 1,
        consts: () => {
          let i18n_3;
          if (typeof ngI18nClosureMode !== "undefined" && ngI18nClosureMode) {
            /**
             * @suppress {msgDescriptions}
             */
            const MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_3 = goog.getMsg(" See all products ");
            i18n_3 = MSG__BUILDS_SCALEFAST_STORES_ORAL_B_ORAL_B_FRANCE_SPAIN_STORE_NODE_MODULES__SCALEFAST_ECOMMERCE_COMPONENTS_FESM2022_SCALEFAST_ECOMMERCE_COMPONENTS_MJS_3;
          } else {
            i18n_3 = $localize`:@@SEE_ALL_PRODUCTS: See all products `;
          }
          return [i18n_3, [1, "navigation__list-dropdown"], [1, "bottom_link"], ["data-gtmaction", "event_menu_click", "data-gtmcategory", "event_informational_action", 1, "btn-underline-hov", 3, "routerLink"], [1, "navigation__list-item", "navigation__list-item--second-level"], ["data-gtmaction", "event_menu_click", "data-gtmcategory", "event_informational_action", 1, "navigation__list-item-link", 3, "click", "routerLink"], [1, "navigation__list-item-img"], [1, "circle-arrow-before", 3, "innerHtml"], ["aria-hidden", "true", "tabindex", "-1", "ngSrcset", "160w, 40w", "width", "160", "height", "160", "placeholder", "", 1, "ls-is-cached", "lazyloaded", "category-img", 3, "ngSrc", "alt", "loaderParams"], ["data-gtmaction", "event_menu_click", "data-gtmcategory", "event_informational_action", 1, "btn-underline-hov", 3, "click", "routerLink"]];
        },
        template: function EcommerceStoreNavDropdownComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "ul", 1);
            i0.ɵɵrepeaterCreate(1, EcommerceStoreNavDropdownComponent_For_2_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementStart(3, "li", 2);
            i0.ɵɵtemplate(4, EcommerceStoreNavDropdownComponent_Conditional_4_Template, 2, 3, "a", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.item.childLinks);
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.item.linkedPage ? 4 : -1);
          }
        },
        dependencies: [RouterModule, i2$1.RouterLink, NgOptimizedImage],
        encapsulation: 2
      });
    }
  }
  return EcommerceStoreNavDropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StoreNavItemComponent = /*#__PURE__*/(() => {
  class StoreNavItemComponent {
    #prefetchService;
    constructor(router, destroyRef) {
      this.router = router;
      this.destroyRef = destroyRef;
      this.clickMenuItem = new EventEmitter();
      this.opened = model(-1);
      this.isOpen = computed(() => this.opened() === this.index);
      this.shapeColor = null;
      this.fontColor = null;
      this.linksMenu = false;
      this.#prefetchService = inject(PrefetchService);
      this.isActive = toSignal(this.isActive$);
    }
    ngOnInit() {
      this.linksMenu = this.item.dropdownStyle === 'links' ? true : false;
    }
    get isActive$() {
      return this.router.events.pipe(takeUntilDestroyed(this.destroyRef), filter(event => {
        return event instanceof NavigationEnd;
      }), map$1(event => {
        //force NavigationEnd, angular compiler is too stupid to infer it.
        return event.url === this.item.linkedPage;
      }));
    }
    clickMenuItemHandler(event) {
      if (!event.event.status) {
        this.closeDropdown();
      }
      this.clickMenuItem.emit({
        event: 'APP_MENU_CLICK',
        status: this.isOpen()
      });
    }
    closeDropdown() {
      this.opened.set(-1);
    }
    openDropdown() {
      this.opened.set(this.index);
    }
    toggleDropdown() {
      this.opened.update(i => i === this.index ? -1 : this.index);
    }
    clickItem() {
      this.clickMenuItem.emit({
        event: 'APP_MENU_CLICK',
        status: this.isOpen()
      });
    }
    prefetchPage(item) {
      if (item.linkedPage) {
        const [path, queryParams = ''] = item.linkedPage.split(/\?(.*)/);
        const queryParamsObject = Object.fromEntries(new URLSearchParams(queryParams));
        this.#prefetchService.prefetchPage(path, queryParamsObject);
      }
      if (item.childLinks) {
        item.childLinks.forEach(child => {
          this.prefetchPage(child);
        });
      }
    }
    static {
      this.ɵfac = function StoreNavItemComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StoreNavItemComponent)(i0.ɵɵdirectiveInject(i2$1.Router), i0.ɵɵdirectiveInject(i0.DestroyRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StoreNavItemComponent,
        selectors: [["ecommerce-store-nav-item"]],
        inputs: {
          item: "item",
          index: "index",
          opened: [1, "opened"]
        },
        outputs: {
          clickMenuItem: "clickMenuItem",
          opened: "openedChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 11,
        consts: [[1, "navbar__item", "dropdown", 3, "openChange", "ngClass"], [1, "navigation__list-item-link", 3, "routerLink", "ngClass", "ngStyle"], [1, "navigation__list-item-link", 3, "click", "mouseenter", "routerLink", "ngClass", "ngStyle"], [3, "innerHtml"], ["type", "button", "role", "button", "aria-haspopup", "true", "aria-expanded", "false", 1, "dropdown-toggle", "btn-dropdown", 3, "click", "mouseenter", "ngClass", "id", "ngStyle"], ["tabindex", "0", 1, "menu-backdrop", 3, "keypress", "click", "ngClass"], [1, "dropdown-menu", "megamenu", 3, "id", "ngClass"], [1, "container", "megamenu-wrapper"], [3, "item", "isVisible"], ["data-internal-id", "submenu", "type", "button", "data-toogle", "dropdown", "aria-haspopup", "true", "aria-expanded", "false", "tabindex", "0", 1, "btn-close", "close", 3, "keypress", "click"], [3, "eventClickItem", "clickMenuItem", "item", "isVisible"]],
        template: function StoreNavItemComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("openChange", function StoreNavItemComponent_Template_div_openChange_0_listener() {
              return ctx.toggleDropdown();
            });
            i0.ɵɵtemplate(1, StoreNavItemComponent_Conditional_1_Template, 2, 11, "a", 1)(2, StoreNavItemComponent_Conditional_2_Template, 9, 18, "ng-container");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction7(3, _c9, !ctx.item.customizeLink.image, ctx.item.customizeLink.bold, ctx.item.customizeLink.italic, ctx.item.customizeLink.underline, ctx.shapeColor, ctx.isActive() || ctx.isOpen(), ctx.isOpen()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.item.childLinks || ctx.item.childLinks.length === 0 ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.item.childLinks && ctx.item.childLinks.length > 0 ? 2 : -1);
          }
        },
        dependencies: [NgClass, NgStyle, RouterModule, i2$1.RouterLink, EcommerceStoreNavDropdownComponent, EcommerceStoreNavDropdownLinksComponent],
        encapsulation: 2
      });
    }
  }
  return StoreNavItemComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StoreNavComponent = /*#__PURE__*/(() => {
  class StoreNavComponent {
    set isMobileOpen(value) {
      if (value == this._isMobileOpen) {
        return;
      }
      this._isMobileOpen = value;
      this.toggleMenu(this._isMobileOpen);
    }
    get isMobileOpen() {
      return this._isMobileOpen;
    }
    constructor(loginService, navMenuService) {
      this.loginService = loginService;
      this.navMenuService = navMenuService;
      this.isSticky = false;
      this.backdropClick = new EventEmitter();
      this._isMobileOpen = false;
      this.renderMobileMenu = false;
      this.opened = signal(-1);
      this.items = toSignal(this.navMenuService.navContent$);
      this.isLogged$ = this.loginService.isLogged();
    }
    toggleMenu(value) {
      if (value == true) {
        document.documentElement.classList.add('mob-menu_open');
      } else {
        document.documentElement.classList.remove('mob-menu_open');
        this.emitBackdropClick(false);
      }
    }
    emitBackdropClick(value) {
      this.backdropClick.emit(value);
    }
    clickMenuItemHandler(event) {
      this.toggleMenu(event.event.status);
    }
    static {
      this.ɵfac = function StoreNavComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StoreNavComponent)(i0.ɵɵdirectiveInject(i1.LoginService), i0.ɵɵdirectiveInject(i1.NavMenuService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: StoreNavComponent,
        selectors: [["ecommerce-store-nav"]],
        viewQuery: function StoreNavComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c13, 5, TemplateRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.childrenTemplate = _t.first);
          }
        },
        inputs: {
          isMobileOpen: "isMobileOpen",
          isSticky: "isSticky",
          headerTop: "headerTop"
        },
        outputs: {
          backdropClick: "backdropClick"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 10,
        vars: 10,
        consts: [["id", "main_nav"], ["id", "menu-backdrop", "tabindex", "0", 1, "menu-backdrop", 3, "keyup", "click", "ngClass"], ["id", "primary_nav-container", 3, "ngClass"], ["id", "primary_nav", 3, "ngClass"], [1, "primary_nav-top"], [1, "close-container"], ["type", "button", 1, "btn-close", "close", 3, "keyup", "click"], [1, "navbar"], [1, "navbar__item-container"], [3, "openedChange", "clickMenuItem", "item", "index", "opened"]],
        template: function StoreNavComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "nav", 0)(1, "div", 1);
            i0.ɵɵlistener("keyup", function StoreNavComponent_Template_div_keyup_1_listener() {
              ctx.isMobileOpen = false;
              return ctx.emitBackdropClick(false);
            })("click", function StoreNavComponent_Template_div_click_1_listener() {
              ctx.isMobileOpen = false;
              return ctx.emitBackdropClick(false);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "button", 6);
            i0.ɵɵlistener("keyup", function StoreNavComponent_Template_button_keyup_6_listener() {
              ctx.isMobileOpen = false;
              return ctx.emitBackdropClick(false);
            })("click", function StoreNavComponent_Template_button_click_6_listener() {
              ctx.isMobileOpen = false;
              return ctx.emitBackdropClick(false);
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "ul", 7);
            i0.ɵɵrepeaterCreate(8, StoreNavComponent_For_9_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()()()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c12, ctx.isMobileOpen));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c12, ctx.isMobileOpen));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c14, ctx.isMobileOpen, ctx.isSticky));
            i0.ɵɵadvance(5);
            i0.ɵɵrepeater(ctx.items());
          }
        },
        dependencies: [NgClass, StoreNavItemComponent],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return StoreNavComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubscribeNewsletterComponent = /*#__PURE__*/(() => {
  class SubscribeNewsletterComponent {
    constructor(formBuilder) {
      this.formBuilder = formBuilder;
      this.emailPlaceholder = input('Email');
      this.submitLabel = input('Subscribe');
      this.sectionTitle = input('Subscribe to our newsletter');
      this.checkboxNewsletterText = input('I have read and agree with the');
      this.checkboxPromotionText = input('I want promotions');
      this.linkText = input('Privacy Policy.');
      this.namePlaceholder = input('Full Name');
      this.hasNewsletter = true;
      this.isSubmitted = false;
      this.isPromotionChecked = false;
      this.isNewsletterChecked = false;
      this.extraInputs = [];
      this.subscribeNewsletterModalService = inject(SubscribeNewsletterModalService);
      this.subscribeNewsletterService = inject(SubscribeNewsletterService);
      this.newsletterForm = new FormGroup('');
    }
    get subscribedToNewsletter() {
      return this.subscribeNewsletterService.subscribed;
    }
    ngOnInit() {
      this.newsletterForm = this.formBuilder.group({
        email: new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$')]),
        subscribe_newsletter: new FormControl(false, [Validators.required]),
        subscribe_promotion: new FormControl(false)
      });
      this.extraInputs.map(input => {
        this.newsletterForm.addControl(input.name, input.formControl);
      });
    }
    get formControls() {
      return this.newsletterForm.controls;
    }
    subscribeNewsletter() {
      this.isSubmitted = true;
      if (this.newsletterForm.invalid) {
        return;
      }
      const subscribeNewsletterForm = {
        email: this.newsletterForm.controls.email.value,
        subscribe_newsletter: this.newsletterForm.controls.subscribe_newsletter.value,
        subscribe_promotion: this.newsletterForm.controls.subscribe_promotion.value
      };
      if (this.extraInputs.length > 0) {
        const extra = {};
        this.extraInputs.map(input => {
          const value = input.formControl.value;
          const key = input.name;
          extra[key] = [{
            value: value
          }];
        });
        subscribeNewsletterForm.extra = extra;
      }
      this.subscribeNewsletterService.subscribe(subscribeNewsletterForm);
      // This asapScheduler is here in order to clear the subscribe form after the user has been subscribed
      asapScheduler.schedule(() => {
        this.clearNewsletterForm();
      }, 3000);
      this.closeNewsletterModal();
    }
    onPrivacyPolicyCheckChange() {
      this.isNewsletterChecked = !this.isNewsletterChecked;
    }
    onPromotionCheckChange() {
      this.isPromotionChecked = !this.isPromotionChecked;
    }
    clearNewsletterForm() {
      this.newsletterForm.reset();
      this.newsletterForm.markAsPristine();
      Object.keys(this.newsletterForm.controls).forEach(key => {
        this.newsletterForm.get(key)?.setErrors(null);
      });
      this.newsletterForm.controls.email.setValue('');
      this.extraInputs.map(input => {
        this.newsletterForm.get(input.name)?.setValue('');
      });
      this.isSubmitted = false;
      this.isNewsletterChecked = false;
      this.isPromotionChecked = false;
    }
    closeNewsletterModal() {
      setTimeout(() => {
        this.subscribeNewsletterModalService.hideModalAndSetLocalStorage();
      }, 10000);
    }
    static {
      this.ɵfac = function SubscribeNewsletterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubscribeNewsletterComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SubscribeNewsletterComponent,
        selectors: [["ecommerce-subscribe-newsletter"]],
        inputs: {
          emailPlaceholder: [1, "emailPlaceholder"],
          submitLabel: [1, "submitLabel"],
          sectionTitle: [1, "sectionTitle"],
          checkboxNewsletterText: [1, "checkboxNewsletterText"],
          checkboxPromotionText: [1, "checkboxPromotionText"],
          linkText: [1, "linkText"],
          namePlaceholder: [1, "namePlaceholder"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [[1, "border-top", "pt-4", "pb-4"], [1, "container-fluid", "subscribe-newsletter"], [1, "row"], [1, "col-12", "col-md-6"], [1, "mb-3"], [1, "mb-2"], [3, "ngSubmit", "formGroup"], [1, "mb-2", "p-2"], [1, "form-check"], ["type", "checkbox", "formControlName", "subscribe_newsletter", "name", "newsletterCheckBox", "required", "", "id", "newsletterCheckBoxId", 1, "form-check-input", 3, "change", "ngClass", "checked"], ["for", "newsletterCheckBoxId", 1, "form-check-label"], [1, "text-decoration-underline", "text-reset", 3, "routerLink"], ["type", "checkbox", "formControlName", "subscribe_promotion", "name", "promotionCheckBox", "id", "promotionCheckBoxId", 1, "form-check-input", 3, "change", "checked"], [1, ""], [1, "col-lg-6"], ["type", "email", "formControlName", "email", "name", "email", "required", "", 1, "form-control", "is-valid", "lh-lg", 3, "ngClass", "placeholder"], [1, "valid-feedback"], [1, "col-lg-6", "button-wrapper"], ["type", "submit", 1, "btn", "btn-primary", "btn-block", "w-100", 3, "disabled"]],
        template: function SubscribeNewsletterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, SubscribeNewsletterComponent_Conditional_0_Template, 29, 20, "section", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.hasNewsletter ? 0 : -1);
          }
        },
        dependencies: [ReactiveFormsModule, i1$1.ɵNgNoValidate, i1$1.DefaultValueAccessor, i1$1.CheckboxControlValueAccessor, i1$1.NgControlStatus, i1$1.NgControlStatusGroup, i1$1.RequiredValidator, i1$1.CheckboxRequiredValidator, i1$1.FormGroupDirective, i1$1.FormControlName, NgClass, RouterLink],
        encapsulation: 2
      });
    }
  }
  return SubscribeNewsletterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SubscribeNewsletterModalComponent = /*#__PURE__*/(() => {
  class SubscribeNewsletterModalComponent {
    constructor() {
      this.subscribeNewsletterModalService = inject(SubscribeNewsletterModalService);
      this.sourceId = 'newsletter-popup';
    }
    /** This component is always rendered in SSR.
     * When initialize, it checks if 'hide_newsletter' is present in local storage,
     * and set the CSS variable value (--subscribe-newsletter-display) accordinly
     * The modal display is managed by that CSS variable.
     */
    ngOnInit() {
      if (this.subscribeNewsletterModalService.shouldIShowModalOnLoad()) {
        this.subscribeNewsletterModalService.showModal();
      }
    }
    close() {
      this.subscribeNewsletterModalService.hideModalAndSetLocalStorage();
    }
    static {
      this.ɵfac = function SubscribeNewsletterModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SubscribeNewsletterModalComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SubscribeNewsletterModalComponent,
        selectors: [["ecommerce-subscribe-newsletter-modal"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 1,
        consts: [[1, "newsletter-modal", 3, "id"], [1, "newsletter-modal-dialog"], [1, "newsletter-modal-content"], [1, "newsletter-modal-header"], ["type", "button", "id", "modal-dismiss", "aria-label", "Close", 1, "newsletter-btn-close", 3, "click"], [1, "newsletter-modal-body"]],
        template: function SubscribeNewsletterModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "button", 4);
            i0.ɵɵlistener("click", function SubscribeNewsletterModalComponent_Template_button_click_4_listener() {
              return ctx.close();
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 5);
            i0.ɵɵelement(6, "ecommerce-subscribe-newsletter");
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("id", ctx.sourceId);
          }
        },
        dependencies: [SubscribeNewsletterComponent],
        styles: ["@charset \"UTF-8\";.newsletter-modal[_ngcontent-%COMP%]{display:var(--subscribe-newsletter-display);background-color:#00000080;max-width:100vw;position:fixed;top:0;left:0;z-index:1055;width:100%;height:100%;outline:0;padding:1rem}.newsletter-modal-dialog[_ngcontent-%COMP%]{max-width:900px;margin-left:auto;margin-right:auto;position:relative;width:auto;margin-top:.75rem;pointer-events:none}.newsletter-modal-content[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;width:100%;pointer-events:auto;background-color:#fff;background-clip:padding-box;outline:0}.newsletter-modal-header[_ngcontent-%COMP%]{padding:0;border:none;justify-content:center;display:flex;flex-shrink:0;align-items:center}.newsletter-btn-close[_ngcontent-%COMP%]{position:absolute;right:15px;top:15px;z-index:200;background-color:#002d72;height:40px;width:40px;border-radius:50%;opacity:1;padding:0;margin:-.5rem -.5rem -.5em auto;color:#fff;border:0}.newsletter-btn-close[_ngcontent-%COMP%]:before{content:\"\\2716\"}.newsletter-btn-close[_ngcontent-%COMP%]:hover{text-decoration:none;opacity:.75}"]
      });
    }
  }
  return SubscribeNewsletterModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AlertListComponent, ContactFormComponent, CrossSellProductsComponent, CustomerInfoFormComponent, EcommerceProductDescriptionTabsComponent, FilterComponent, ForgotPasswordFormComponent, LanguageSelectorComponent, LoginButtonComponent, LoginFormComponent, MainCarouselComponent, MaintenanceModule, MinicartComponent, ProductAddedToCartComponent, ProductCarouselComponent, ProductDescriptionAccordionComponent, ProductGalleryComponent, ProductPriceComponent, ProductShortDescriptionComponent, ProductTitleComponent, RegisterFormComponent, RemoveProductFromCartComponent, ResetPasswordFormComponent, ScalefastAddToCartComponent, SearchBarComponent, SearchFilterComponent, SpinnerComponent, StoreNavComponent, SubscribeNewsletterComponent, SubscribeNewsletterModalComponent };
